<template>
  <div
    :style="style"
    ref="vueDragResizable"
    :data-appId="options && options.appId ? options.appId : ''"
    :class="[
      {
        [classNameActive]: enabled && !dragging,
        [classNameDragging]: dragging,
        [classNameResizing]: resizing,
        [classNameDraggable]: isDraggable,
        [classNameResizable]: resizable
      },
      className,
      options && options.showBackgroundFilter && options.backgroundFilter ? 'vdr-backgroundFilter':''
    ]"
    @click.stop="childClickBubbleFunc"
    @mouseenter.stop="elementMouseEnter"
    @mouseleave.stop="elementMouseLeave"
    @mousedown.stop="elementMouseDown"
    @touchstart.stop="elementTouchDown"
    v-show="isElementShow"
  >
    <div v-show="resizing" class="size-popover">
      {{ Number.isNaN(width) ? " W: auto" : " W: " + parseInt(width) }}
      {{ Number.isNaN(height) ? " H: auto" : " H:" + parseInt(height) }}
    </div>
    <div
      v-show="!isGridResizing"
      v-for="handle in actualHandles"
      :key="handle"
      :class="[classNameHandle, classNameHandle + '-' + handle]"
      :style="handleStyle(handle)"
      @mousedown.stop.prevent="handleDown(handle, $event)"
      @touchstart.stop.prevent="handleTouchDown(handle, $event)"
    >
      <slot :name="handle"></slot>
    </div>
    <div
      v-for="handle in borderHandles"
      :key="handle"
      :class="[classNameHandle, classNameHandle + '-' + handle]"
      :style="borderHandleStyle"
    >
      <slot :name="handle"></slot>
    </div>
    <div
      v-if="!isLayoutTitle && request_prefix === 'bigScreen' && !isBigScreenPreview()"
      class="handle-btn-groups"
      ref="del"
      :class="[
        enabled && !draggingOrResizing && !resizing ? 'isShow' : 'isHid',
        isShowModuleHandles && x > 20 ? 'right0' : '',
        y < 38 ? 'is_top' : '',
        x < 20 ? '' : ''
      ]"
    >
      <div>
        <span
          v-if="
            shape === 'emptyLayoutComponent' ||
            shape === 'layoutComponent' ||
            disableSetColAndRow ||
            (shape === 'swiperComponent' && showSetComponentBtn)
          "
          class="handle-icon-box"
          @mousedown.stop
          ><i class="icon icon-portal-card-view"></i><span class="icon-tips">容器设置</span></span
        >
        <span class="handle-icon-box delete" @mousedown.stop @click.stop="del"
          ><i class="icon icon-portal-delete"></i><span class="icon-tips">删除</span></span
        >
      </div>
    </div>
    <!-- 2.0新的菜单按钮样式 -->
    <handle-btn-groups
      v-if="request_prefix !== 'bigScreen' && !clonePatternStatu && !isGridResizing"
      ref="handleBtns"
      :ids="myId"
      :isCanDel="!isPageLayoutTabs && !isAnchor && isCanDel"
      :isClone="isAnchor"
      :shape="shape"
      :options="options"
      :handleList="getHandleList"
      :isActive="activeSingle"
      handleType="rect"
      :enabled="enabled"
      @delElement="del"
      @cloneElement="clone"
      @openBox="openBox"
      @removeLayout="removeLayoutHandle"
      :isAllHandleBtns="true"
      :class="[
        'handle-btn-groups new-btn-groups',
        (enabled || isHover) && !draggingOrResizing && !resizing ? 'isShow' : 'isHid',
        isShowModuleHandles && x > 20 ? 'right0' : '',
        offsetType
      ]"
      :style="getHandleTopSite"
      :forbiden="forbiden"
    />
    <!-- 设置毛玻璃效果 -->
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.bigScreenStage .vdr {
  &:hover {
    outline: none;
  }
}
.hoverIndexTop.vdr.vdr_hover {
  z-index: 100000 !important;
}
.vdr {
  touch-action: none;
  position: absolute;
  box-sizing: border-box;
  &.active {
    cursor: default;
    z-index: 99999 !important;
  }
  &.vdr_hover {
    &.is_full_rect{
      z-index: 1 !important; // 悬浮需要显示菜单栏 提高一点层级
    }
    & > .handle-tb,
    & > .handle-rb,
    & > .handle-bb,
    & > .handle-lb {
      display: block !important;
    }
  }
  &.active {
    & > .handle-tb {
      border-top: 2px dashed var(--themeColor);
    }
    & > .handle-bb {
      border-bottom: 2px dashed var(--themeColor);
    }
    & > .handle-rb {
      border-right: 2px dashed var(--themeColor);
    }
    & > .handle-lb {
      border-left: 2px dashed var(--themeColor);
    }
  }
}
.bigScreen {
  .vdr {
    &.active {
      & > .handle-tb,
      & > .handle-bb {
        height: 2px;
        border: 0;
      }
      & > .handle-rb,
      & > .handle-lb {
        width: 2px;
        border: 0;
      }
    }
  }
}
.isShow .top {
  text-align: center;
}

.isShow .item {
  margin: 4px;
}

.hover:hover {
  cursor: pointer;
}

.isHid {
  display: none !important;
}

.vdr:not(.active):not(.vdr_hover) > .new-btn-groups {
  display: none !important;
}

.vdr:not(.active):not(.vdr_hover):not(.resizing):not(.hover-active) > .handle {
  display: none !important;
}

.is_grid {
  top: 0;
  left: 0
}


.handle {
  box-sizing: border-box;
  position: absolute;
  width: 6px;
  height: 6px;
  border: 2px solid var(--themeColor);
  z-index: 999;
}

.handle-tl {
  top: -5px;
  left: -5px;
  cursor: nwse-resize;
  background-color: #fff;
  z-index: 1002;
  border-radius: 50%;
}

.handle-tm {
  left: 0 !important;
  right: 0;
  width: 100% !important;
  border-radius: 0;
  border: 0;
  cursor: ns-resize;
}

.handle-tr {
  top: -5px;
  right: -5px;
  cursor: nesw-resize;
  background-color: #fff;
  z-index: 1000;
  border-radius: 50%;
}

.handle-ml {
  top: 0 !important;
  height: 100% !important;
  border: 0;
  border-radius: 0;
  cursor: ew-resize;
}

.handle-mr {
  top: 0 !important;
  height: 100% !important;
  border: 0;
  border-radius: 0;
  cursor: ew-resize;
}

.handle-bl {
  bottom: -5px;
  left: -5px;
  cursor: nesw-resize;
  background-color: #fff;
  z-index: 1000;
  border-radius: 50%;
}

.handle-bm {
  left: 0;
  right: 0;
  width: 100% !important;
  border-radius: 0;
  cursor: ns-resize;
  border: 0;
}

.handle-br {
  bottom: -5px;
  right: -5px;
  cursor: nwse-resize;
  background-color: #fff;
  z-index: 1000;
  border-radius: 50%;
}

.ref-line {
  position: absolute;
  background-color: rgb(255, 0, 204);
  z-index: 9999;
}

.v-line {
  width: 1px;
}

.h-line {
  height: 1px;
}
.container_placeholder {
  position: absolute;
  width: 100%;
  top: -60px;
  text-align: center;
  display: block;
  font-size: 14px;
  line-height: 20px;
  color: var(--themeColor);
  padding: 20px;
  box-sizing: border-box;
  background: rgba(61, 130, 242, 0.1);
  border: 1px dashed var(--themeColor);
  z-index: 9999;
}

@media only screen and (max-width: 768px) {
  [class*="handle-"]:before {
    content: "";
    left: -10px;
    right: -10px;
    bottom: -10px;
    top: -10px;
    position: absolute;
  }
}
.right80 {
  right: 80px;
}
.right0 {
  right: 0;
}
.size-popover {
  position: absolute;
  background: rgba(24, 30, 51, 0.8);
  border-radius: 4px;
  top: -32px;
  left: 0;
  z-index: 10;
  font-size: 12px;
  line-height: 17px;
  padding: 5px 12px;
  color: #fff;
}
.rerender {
  text-align: center;
  margin-left: 10px;
}
.other_content .delete {
  display: none;
}
.handle-btn-groups.is_left {
  left: 0;
  right: auto;
}
.handle-btn-groups.is_left + .saveModule {
  left: 98px; //暂定98px,后期进行优化
  right: auto;
}
.handle-btn-groups.is_top {
  margin-top: 0;
}
.handle-btn-groups.is_top + .saveModule {
  top: 0;
}
.handle-btn-groups.is_top .handle-icon-box .icon-tips {
  top: 38px;
}
.handle-btn-groups.is_top .handle-icon-box .icon-tips:after {
  top: -10px;
  bottom: auto;
  transform: rotate(180deg);
}
.handle-tb {
  left: 0;
  right: 0;
  width: 100%;
  border: 0;
  display: none;
  border-top: 1px dashed var(--themeColor);
}
.handle-rb {
  height: 100%;
  right: 0;
  border: 0;
  display: none;
  border-right: 1px dashed var(--themeColor);
}
.handle-bb {
  left: 0;
  right: 0;
  width: 100%;
  bottom: 0;
  border: 0;
  display: none;
  border-bottom: 1px dashed var(--themeColor);
}
.handle-lb {
  height: 100%;
  top: 0;
  left: 0;
  // width: 1px;
  border: 0;
  // background: var(--themeColor);
  display: none;
  border-left: 1px dashed var(--themeColor);
}
</style>
<script>
import { matchesSelectorToParentElements, getComputedSize, addEvent, removeEvent } from "../../../utils/dom"
import { computeWidth, computeHeight, restrictToBounds, snapToGrid } from "../../../utils/fns"
import {
  _throttle,
  findParentIds,
  hasProperty,
  isEqual,
  findCurrentComponentPathInLayoutByRectId,
  isExist,
  fixOptName,
  simpleDeepClone,
  handleFindLayoutComponentOptionsCols,
  findPathInComponentLayoutByRectId
} from "../../../utils/index"
import animateMixin from "utils/event/animateMixin.js"
import handleBtnGroups from "../handleBtnGroups"
import { copyAnimateRelation } from "../../../utils/event/animate"
import $ from "jquery"
import { CATEGORY_MODE } from "@/consts/index.js"

const events = {
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  },
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  }
}

// 禁止用户选取
const userSelectNone = {
  userSelect: "none",
  MozUserSelect: "none",
  WebkitUserSelect: "none",
  MsUserSelect: "none"
}
// 用户选中自动
const userSelectAuto = {
  userSelect: "auto",
  MozUserSelect: "auto",
  WebkitUserSelect: "auto",
  MsUserSelect: "auto"
}

let eventsFor = events.mouse
export default {
  mixins: [animateMixin],
  replace: true,
  name: "vue-draggable-resizable",
  props: {
    isGridItem: Boolean,
    isGridResizing: Boolean,
    isAnchor: {
      type: Boolean,
      default: false
    },
    isWaterItem: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object
    },
    isLayoutTitle: {
      type: Boolean,
      default: false
    },
    snapWithAdsorbent: {
      type: Boolean,
      default: true
    },
    elementName: {
      type: String,
      default: null
    },
    uid: {
      type: String,
      default: null
    },
    myId: {
      type: Object,
      default: () => {
        return {}
      }
    },
    direction: {
      type: Number,
      default: null
    },
    elementInLayoutId: {
      type: Number,
      default: null
    },
    swiperContentId: {
      type: Number,
      default: null
    },
    className: {
      type: String,
      default: "vdr"
    },
    classNameDraggable: {
      type: String,
      default: "draggable"
    },
    classNameResizable: {
      type: String,
      default: "resizable"
    },
    classNameDragging: {
      type: String,
      default: "dragging"
    },
    parentW: {
      type: Number,
      default: null
    },
    parentH: {
      type: Number,
      default: null
    },
    classNameResizing: {
      type: String,
      default: "resizing"
    },
    classNameActive: {
      type: String,
      default: "active"
    },
    classNameHandle: {
      type: String,
      default: "handle"
    },
    disableUserSelect: {
      type: Boolean,
      default: true
    },
    enableNativeDrag: {
      type: Boolean,
      default: false
    },
    preventDeactivation: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: true
    },
    resizable: {
      type: Boolean,
      default: true
    },
    // 锁定宽高比
    lockAspectRatio: {
      type: Boolean,
      default: false
    },
    w: {
      type: [Number, String],
      default: 200
    },
    h: {
      type: [Number, String],
      default: 200
    },
    minWidth: {
      type: Number,
      default: 0,
      validator: val => val >= 0
    },
    minHeight: {
      type: Number,
      default: 0,
      validator: val => val >= 0
    },
    maxWidth: {
      type: Number,
      default: null,
      validator: val => val >= 0
    },
    maxHeight: {
      type: Number,
      default: null,
      validator: val => val >= 0
    },
    zoom: {
      type: Number,
      default: 1
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    },
    z: {
      type: [String, Number],
      default: "auto",
      validator: val => (typeof val === "string" ? val === "auto" : val >= 0)
    },
    rectId: {
      type: [Number, String],
      default: null
    },
    containerId: {
      type: Number,
      default: null
    },
    shape: {
      type: String,
      default: "rect"
    },
    handles: {
      type: Array,
      default: () => ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"],
      validator: val => {
        const s = new Set(["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"])
        return new Set(val.filter(h => s.has(h))).size === val.length
      }
    },
    dragHandle: {
      type: String,
      default: null
    },
    dragCancel: {
      type: String,
      default: null
    },
    axis: {
      type: String,
      default: "both",
      validator: val => ["x", "y", "both"].includes(val)
    },
    grid: {
      type: Array,
      default: () => [1, 1]
    },
    parent: {
      type: [Boolean, String],
      default: true
    },
    onDragStart: {
      type: Function,
      default: () => true
    },
    onDrag: {
      type: Function,
      default: () => true
    },
    onResizeStart: {
      type: Function,
      default: () => true
    },
    onResize: {
      type: Function,
      default: () => true
    },
    // 冲突检测
    isConflictCheck: {
      type: Boolean,
      default: false
    },
    // 元素对齐
    snap: {
      type: Boolean,
      default: true
    },
    // 当调用对齐时，用来设置组件与组件之间的对齐距离，以像素为单位
    snapTolerance: {
      type: Number,
      default: 5,
      validator: function (val) {
        return typeof val === "number"
      }
    },
    // handle是否缩放
    handleInfo: {
      type: Object,
      default: () => {
        return {
          size: 8,
          offset: -2,
          switch: true
        }
      }
    },
    isShowModuleHandles: {
      type: Boolean,
      default: false
    },
    swiperMode: {
      type: Boolean
    },
    clickBubble: {
      type: Boolean,
      default: false
    },
    // 是否禁止操作元素
    forbiden: {
      type: Boolean,
      default: false
    },
    elementInAutoLayoutId: {
      type: Number,
      default: null
    },
  },
  components: { handleBtnGroups },
  data: function () {
    return {
      left: this.x,
      top: this.y,
      right: null,
      bottom: null,

      width: null,
      height: null,
      widthTouched: false,
      heightTouched: false,
      aspectFactor: null,

      parentWidth: null,
      parentHeight: null,

      minW: this.minWidth,
      minH: this.minHeight,

      maxW: this.maxWidth,
      maxH: this.maxHeight,

      handle: null,
      enabled: false,
      resizing: false,
      dragging: false,
      draggingOrResizing: false,
      zIndex: this.z,
      handleBtnStr: {
        iconClass: "",
        name: ""
      },
      offsetLeft: 0,
      offsetTop: 0,
      optionsHeight: this.parentH,
      handleList: [],
      borderList: ["tb", "rb", "bb", "lb"],
      isHover: false,
      showMultipleName: false,
      offsetType: "top-bottom", // top-top、top-bottom、bottom-top、bottom-bottom表示：从上往上排列，从上往下排列，从下往上排列，从下往下排列
      preparingDag: false
    }
  },

  created: function () {
    // eslint-disable-next-line 无效的prop：minWidth不能大于maxWidth
    if (this.maxWidth && this.minWidth > this.maxWidth)
      console.warn("[Vdr warn]: Invalid prop: minWidth cannot be greater than maxWidth")
    // eslint-disable-next-line 无效prop：minHeight不能大于maxHeight'
    if (this.maxWidth && this.minHeight > this.maxHeight)
      console.warn("[Vdr warn]: Invalid prop: minHeight cannot be greater than maxHeight")

    this.resetBoundsAndMouseState()
  },
  mounted: function () {
    if (!this.enableNativeDrag) {
      this.$el.ondragstart = () => false
    }

    const [parentWidth, parentHeight] = !this.parentW  || !this.parentH  || isExist(this.parentW) ?
        this.getParentSize() :
        [this.parentW, this.parentH]
    this.parentWidth = parentWidth
    this.parentHeight = parentHeight
    const [width, height] = getComputedSize(this.$el)
    this.aspectFactor = (this.w !== "auto" ? this.w : width) / (this.h !== "auto" ? this.h : height)
    this.width = this.w !== "auto" ? this.w : width
    this.height = this.h !== "auto" ? this.h : height

    this.right = this.parentWidth - this.width - this.left
    this.bottom = this.parentHeight - this.height - this.top
    this.settingAttribute()
    if (this.isInSubHead) return
    addEvent(document.documentElement, "mousedown", this.deselect, false)
    addEvent(document.documentElement, "touchend touchcancel", this.deselect, false)

    addEvent(window, "resize", this.checkParentSize, false)
    addEvent(document.documentElement, "resize", this.deselect, false)
    if (this.isBigScreenPreview()) this.enabled = false
    else this.enabled = this.active

    if (this.request_prefix !== 'bigScreen' && !this.isBigScreenPreview()) {
      this.resetHandleBtn()
    }
    this.$eventBus.$on("set-anchorId", this.watchAnchor)
  },
  beforeDestroy: function () {
    this.pageLayoutParentOptions = null
    removeEvent(document.documentElement, "mousedown", this.deselect, false)
    removeEvent(document.documentElement, "touchstart", this.handleUp, false)
    removeEvent(document.documentElement, "mousemove", this.move, false)
    removeEvent(document.documentElement, "touchmove", this.move, false)
    removeEvent(document.documentElement, "mouseup", this.handleUp, false)
    removeEvent(document.documentElement, "touchend touchcancel", this.deselect, false)

    removeEvent(window, "resize", this.checkParentSize, false)
    removeEvent(document.documentElement, "resize", this.deselect, false)
    this.$el.ondragstart = null
    removeEvent(document.documentElement, "wheel", this.changeBtnPosition, false)
    this.$eventBus.$off("set-anchorId", this.watchAnchor)
  },

  methods: {
    watchAnchor(anchorList) {
      let flag = false
      let travel = (items, path) => {
        items.forEach((item, index) => {
          let newPath = path ? `${path}_${index}` : `${index}`
          if (item.target && this.$refs.vueDragResizable.classList.contains(item.target.id)) {
            const el = this.$refs.vueDragResizable
            el.classList.add("anchor-item")
            el.setAttribute("data-path", newPath)
            flag = true
          }
          if (item.children && item.children.length > 0) {
            travel(item.children, newPath)
          }
        })
      }
      travel(anchorList || [], "")
      if (!flag) {
        const el = this.$refs.vueDragResizable
        el.classList.remove("anchor-item")
        el.removeAttribute("data-path")
      }
    },
    childClickBubbleFunc() {
      //为了实现自由布局列的交互事件：点击内部组件冒泡到列组件，实现点击整列传参或者跳转。
      if (this.isBigScreenPreview() && this.clickBubble) {
        this.$emit("childClickBubbleParent")
      }
    },
    // 重置设置按钮的图标和文案
    resetHandleBtn() {
      let menuName = this.request_prefix === "appStage" ? "appMenu" : "menu"
      let menu = this.$store.state[menuName].menu
      // console.log('menu',menu);
      // 每个组件都要加上图标名字按钮
      let handleBtnStr = null
      const menuObj = this.materialLoader.getMenuChildByTypeOrName({
        type: this.options?.innerElement,
        typeId: this.options?.componentTypeId,
        stageType: this.request_prefix
      })
      if (menuObj) {
        handleBtnStr = menuObj
      } else {
        for (var i = 0; i < menu.children.length; i++) {
          let childItem = menu.children[i]
          for (var j = 0; j < childItem.children.length; j++) {
            let subChildItem = childItem.children[j]
            // 可以通过componentTypeId与左侧菜单typeId对应
            if (this.options?.componentTypeId && subChildItem.typeId === this.options?.componentTypeId) {
              handleBtnStr = subChildItem
              break
            }
            // 没有componentTypeId 通过innerElement与type对应
            if (
              !this.options?.componentTypeId &&
              this.options?.innerElement &&
              subChildItem.type == this.options?.innerElement
            ) {
              handleBtnStr = subChildItem
              break
            }
          }
          if (handleBtnStr != null) break
        }
      }

      if (handleBtnStr != null) {
        this.handleBtnStr.name = handleBtnStr.name
        if (handleBtnStr.thumbnail) {
          this.handleBtnStr.iconClass = handleBtnStr.thumbnail
        } else {
          this.handleBtnStr.iconClass = handleBtnStr.children?.[0].thumbnail
        }
      }
      // 左侧菜单中没有当前组件特殊处理
      // 单独处理几个特殊情况的组件 文本没在左侧菜单栏 图表的type和innerElement不对应
      switch (this.options?.innerElement) {
        case "layoutComponent":
          if (this.options.menuName === "超星头像" || this.options.name === "超星头像") {
            this.handleBtnStr.iconClass = "icon-portal-menu_avatar"
            this.handleBtnStr.name = "超星头像"
          } else {
            this.handleBtnStr.iconClass = "icon-portal-free_layout"
            this.handleBtnStr.name = "自由布局"
          }
          break
        case "cxPageLayoutComponent":
          if (this.options.layout.options.isAccordionLayout) {
            this.handleBtnStr.name = "手风琴布局"
            this.handleBtnStr.iconClass = "icon-portal-accordion"
          } else if(this.options.layout.options.isShowVerticalTabs){
            this.handleBtnStr.name = "竖向标签"
          }else{
            this.handleBtnStr.name = "横向标签"
          }
          break
        case "emptyLayoutComponent":
          if (this.handleBtnStr.name && this.handleBtnStr.iconClass) {
            break
          }
          if (this.options.menuName === "超星头像") {
            this.handleBtnStr.iconClass = "icon-portal-menu_avatar"
            this.handleBtnStr.name = "超星头像"
          } else {
            this.handleBtnStr.iconClass = "icon-portal-free_layout"
            this.handleBtnStr.name = "自由布局"
          }
          break
        case "cxText":
          this.handleBtnStr.iconClass = "icon-portal-menu_text1"
          this.handleBtnStr.name = "文本"
          break
        case "cxBar":
          this.handleBtnStr.iconClass = "icon-portal-menu_bar"
          this.handleBtnStr.name = "柱状图"
          break
        case "cxLine":
          this.handleBtnStr.iconClass = "icon-portal-menu_line"
          this.handleBtnStr.name = "折线图"
          break
        case "cxPie":
          this.handleBtnStr.iconClass = "icon-portal-chart-pie"
          this.handleBtnStr.name = "饼图"
          break
        case "cxRadar":
          this.handleBtnStr.iconClass = "icon-portal-chart-radar"
          this.handleBtnStr.name = "雷达图"
          break
        case "cxCloud":
          this.handleBtnStr.iconClass = "icon-portal-chart-textCloud"
          this.handleBtnStr.name = "词云"
          break
        case "cxInput":
          this.handleBtnStr.name = "输入框"
          this.handleBtnStr.iconClass = "icon-portal-input"
          break
        case "cxTabs":
          this.handleBtnStr.name = "标签"
          this.handleBtnStr.iconClass = "icon-portal-tab-small"
          break
        case "cxSelect":
          if (this.options.quoteTo === "cxTabs") {
            this.handleBtnStr.name = "标签"
            this.handleBtnStr.iconClass = "icon-portal-tab-small"
          } else {
            this.handleBtnStr.name = "下拉"
            this.handleBtnStr.iconClass = "icon-portal-icon_select"
          }
          break
        case "cxRadio":
          this.handleBtnStr.name = "单选"
          this.handleBtnStr.iconClass = "icon-portal-radio"
          break
        case "cxPagination":
          this.handleBtnStr.name = "分页"
          this.handleBtnStr.iconClass = "icon-portal-pagination"
          break
        case "cxNoteEditor":
          this.handleBtnStr.name = "笔记编辑器"
          this.handleBtnStr.iconClass = "icon-portal-note"
          break
        case "cxNavMenu":
          this.handleBtnStr.name = "导航菜单"
          this.handleBtnStr.iconClass = "icon-portal-pagination"
          break
        case "cxShape":
          this.handleBtnStr.name = "形状"
          this.handleBtnStr.iconClass = "icon-portal-shape"
          break
        case "cxBreadCrumbs":
          this.handleBtnStr.name = "面包屑"
          this.handleBtnStr.iconClass = "icon-portal-segmenter"
          break
        case "cxNavMenuVertical":
          this.handleBtnStr.name = "树形菜单"
          this.handleBtnStr.iconClass = "icon-portal-menu_navMenu"
          break
        case "cxMultiFilter":
          this.handleBtnStr.name = "多级筛选"
          this.handleBtnStr.iconClass = "icon-portal-list-view"
          break
        case "cxCalendar":
          this.handleBtnStr.name = "日历"
          this.handleBtnStr.iconClass = "icon-portal-calendar"
          break
        case "cxIframe":
          this.handleBtnStr.name = "内嵌网页"
          this.handleBtnStr.iconClass = ""
          break
        case "cxButton":
          if (this.options && this.options.pluginName && this.options.pluginName.includes("getIpPlugin")) {
            this.handleBtnStr.name = "IP"
            this.handleBtnStr.iconClass = "icon-portal_IP"
          }else if(this.options && this.options.pluginName && this.options.pluginName.includes("drawerPlugin")){
            this.handleBtnStr.name = "抽屉按钮"
            this.handleBtnStr.iconClass = "icon-portal-icon_drawer"
          }else if(this.options && this.options.pluginName && this.options.pluginName.includes("popoverPlugin")){
            this.handleBtnStr.name = "弹出框按钮"
            this.handleBtnStr.iconClass = "icon-portal-icon_popover"
          }else if(this.isGoTop){
            this.handleBtnStr.name = "回到顶部按钮"
            this.handleBtnStr.iconClass = "icon-portal-icon_go-top"
          }
          break
        default:
      }

      if (this.options && this.options.pluginName && this.options.pluginName.includes("loginLayoutComponent")) {
        this.handleBtnStr.iconClass = "icon-portal-menu_login"
        this.handleBtnStr.name = "登录组件"
      }
      if (this.options && this.options.pluginName && this.options.pluginName.includes("loginEngineComponentPlugin")) {
        this.handleBtnStr.name = "登录框"
      }
      if (this.options && this.options.pluginName && this.options.pluginName.includes("appNavPlugin")) {
        this.handleBtnStr.name = "移动端导航栏"
      }
      if (this.options && this.options.innerElement === "emptyLayoutComponent" && this.options.name === "列表页搜索") {
        // 特殊判断
        this.handleBtnStr.name = "列表页搜索"
      }
      if (this.request_prefix !== "bigScreen") {
        // 大屏的交互 不需要展示这个图标 并且大屏此处的图标是图片，会被转换成base64
        if (this.myId.elementInAutoLayoutId) {
          let options = this.options
          if (this.myId.hasOwnProperty("uid") || this.myId.hasOwnProperty("elementInLayoutId") || this.myId.hasOwnProperty("elementInSwiperId") || this.myId.hasOwnProperty("cellId") || this.myId.hasOwnProperty("elementInDataGridId")) {
            let ids = {
              container_id: this.myId.container_id,
              rect_id: this.myId.rect_id,
              elementInAutoLayoutId: this.myId.elementInAutoLayoutId,
              path: this.myId.path
            }
            let autoLayoutComponent = this.getAttrById.call(
              this,
              this.$store.state[this.request_prefix],
              ids,
              "autoLayout"
            )
            if (autoLayoutComponent && autoLayoutComponent.innerElement === "cxAutoLayout") {
              options = autoLayoutComponent?.elementOptions.find(it => it.elementInAutoLayoutId === this.myId.elementInAutoLayoutId)
            } else {
              options = autoLayoutComponent
            }
          }
          this.myId.path = options.path
        }
        this.$changeOptionsEV(this.handleBtnStr.name, "menuName", false, null, this.myId, true)
        this.$changeOptionsEV(this.handleBtnStr.iconClass, "menuIconClass", false, null, this.myId, true)
      } else if (this.options && this.options.menuIconClass && this.options.menuIconClass.indexOf("base64") > -1) {
        // 清除大屏base64的脏数据
        this.$changeOptionsEV("", "menuIconClass", false, null, this.myId, true)
      }
      if (!this.options) return
      // 获取当前组件的高度
      if (
        this.options.heightType === "%" ||
        this.options?.innerElement === "emptyLayoutComponent" ||
        this.options?.innerElement === "swiperComponent"
      ) {
        this.optionsHeight = (this.parentHeight * this.options.height) / 100
      } else {
        this.optionsHeight = this.h
      }
      // 获取当前组件距离页面上面的距离
      this.$nextTick(() => {
        this.changeBtnPosition()
      })
    },
    changeBtnPosition(ids) {
      let timer = setTimeout(() => {
        if (this.isGridResizing) return
        // 悬浮时需要重置工具栏位置
        if (!this.active && !ids) return
        let className = ""
        let changeId = ids && ids.hasOwnProperty("container_id") ? ids : this.ids
        if (changeId.container_id != undefined) className += "container_id_" + changeId.container_id
        if (changeId.rect_id != undefined) className += "-rect_id_" + changeId.rect_id
        if (changeId.directionIndex != undefined) className += "-directionIndex_" + changeId.directionIndex
        if (changeId.uid != undefined) className += "-uid_" + changeId.uid
        if (changeId.elementInLayoutId != undefined) className += "-elementInLayoutId_" + changeId.elementInLayoutId
        let element = this.mouseElement
          ? this.mouseElement.getBoundingClientRect()
          : document.getElementsByClassName(className)[0]?.getBoundingClientRect()
        if(element) {
          // 距离页面上边距 = 距离页面顶部距离 - 顶部高度50 - 刻度尺高度24
          const rulerHeight = this.$store.state.states.showRuler ? 0 : 24
          this.offsetTop = element.top - 50 - rulerHeight
          const dragItem = this.$refs.vueDragResizable.getBoundingClientRect()
          const remainHeight = this.offsetTop >= 0 ? dragItem.height : dragItem.height + this.offsetTop
          if(this.offsetTop >= this.maxToolHeight) {
            this.offsetType = "top-top"
          } else if(remainHeight - this.maxToolHeight >= 100) {
            this.offsetType = "top-bottom"
          } else {
            this.offsetType = "bottom-bottom"
          }
        }
        clearTimeout(timer)
      }, 200)
    },
    // 重置边界和鼠标状态
    resetBoundsAndMouseState() {
      this.mouseClickPosition = {
        mouseX: 0,
        mouseY: 0,
        x: 0,
        y: 0,
        w: 0,
        h: 0
      }

      this.bounds = {
        minLeft: null,
        maxLeft: null,
        minRight: null,
        maxRight: null,
        minTop: null,
        maxTop: null,
        minBottom: null,
        maxBottom: null
      }
    },
    // 检查父元素大小
    checkParentSize() {
      if (this.parent) {
        const [newParentWidth, newParentHeight] =
          this.parentW === null ? this.getParentSize() : [this.parentW, this.parentH]
        // 修复父元素改变大小后，组件resizing时活动异常
        this.right = newParentWidth - this.width - this.left
        this.bottom = newParentHeight - this.height - this.top
        this.parentWidth = newParentWidth
        this.parentHeight = newParentHeight
      }
    },
    // 获取父元素大小
    getParentSize() {
      if (this.parent === true) {
        const style = window.getComputedStyle(this.$el.parentNode, null)
        return [parseInt(style.getPropertyValue("width"), 10), parseInt(style.getPropertyValue("height"), 10)]
      }
      if (typeof this.parent === "string") {
        const parentNode = document.querySelector(this.parent)
        if (!(parentNode instanceof HTMLElement)) {
          throw new Error(`The selector ${this.parent} does not match any element`)
        }
        return [parentNode.offsetWidth, parentNode.offsetHeight]
      }

      return [null, null]
    },
    // 元素触摸按下
    elementTouchDown(e) {
      if (this.isBigScreenPreview()) return
      eventsFor = events.touch
      this.elementDown(e)
    },
    elementMouseDown(e) {
        if (this.forbiden || this.shape === 'cxPageLayoutComponent') {
          return
        }
        if (this.isWaterItem) {
          this.checkParentSize()
        }
        this.before = this.getQuickShot()
        if (this.isBigScreenPreview()) return
        eventsFor = events.mouse
        this.elementDown(e)
        if (this.handleBtnStr.name === "" || this.handleBtnStr.name !== this.options.menuName) this.resetHandleBtn()
        // 获取当前组件的高度
        if (
          this.options.heightType === "%" ||
          this.options?.innerElement === "emptyLayoutComponent" ||
          this.options?.innerElement === "swiperComponent"
        ) {
          this.optionsHeight = (this.parentHeight * this.options.height) / 100
        } else {
          this.optionsHeight = this.h
        }
        // 获取当前组件距离页面上面的距离
        this.$nextTick(() => {
          this.changeBtnPosition()
          this.setPageLayoutWrapZindex(true)
          this.setLayoutColZindex(true)
          /* 解决多次切换编辑组件与其他区域导致右侧组件设置弹窗不展示的问题 */
          if (this.options?.innerElement && !this.$store.state.states.elementType) {
            this.$store.commit("states/changeElementType", this.options.innerElement)
          }
          // 当切换组件 把其他组件的展开菜单关闭
          let displayBlock = $(".handle-btn-items.displayBlock")
          if (displayBlock) {
            displayBlock.removeClass("displayBlock")
          }
        })
    },
    elementMouseEnter(e) {
      if(this.isBigScreenPreview()) return
      if (this.isGridResizing) return
      // 如果当前页面有正在拖拽的元素禁止触发外层hover
      if ($(".dragging").length > 0) return
      if (Object.keys(this.myId || {}).length === 0) {
        return
      }
      // 悬浮出现组件名字 自由布局中的组件悬浮不出现工具栏
      if (!isExist(this.myId.directionIndex) && !isExist(this.myId.elementInLayoutId)) {
        this.isHover = true
      }
      if(this.shape === 'cxPageLayoutComponent'){
        return
      }
      this.handleList = this.handleListGetter
      this.mouseElement = e.target
      this.changeBtnPosition(this.handleBtnStr.ids)
      // 除轮播外取消外层自由布局悬浮态
      if (!isExist(this.myId.swiperContent_id) && document.getElementsByClassName("vdr_hover").length > 0) {
        this.layoutElement = document.getElementsByClassName("vdr_hover")[0]
        document.getElementsByClassName("vdr_hover")[0]?.classList.remove("vdr_hover")
      }
      // 取消当前通栏悬浮状态
      this.pageLayout = document.querySelector(".page-layout-wrapper.hover-active")
      if (this.pageLayout) {
        this.pageLayout.classList.remove("hover-active")
      }
      // 取消当前布局active状态
      this.layout = document.querySelector(".layout-container.active")
      if (this.layout) {
        this.layout?.classList.remove("active")
      }
      // 取消自由布局四边栏hover状态
      this.otherContent = document.querySelector(".other_content.hover")
      if (this.otherContent) {
        this.otherContent?.classList.remove("hover")
      }
      // 取消当前栅格布局的悬浮状态
      this.waterGridItem = document.querySelector(".vue-grid-item.hover")
      if (this.waterGridItem) {
        this.waterGridItem?.classList.remove("hover")
      }
      // 当前元素添加悬浮态
      e.target.classList.add("vdr_hover")
      // 鼠标移入自由布局内组件时 取消单元格悬浮状态
      if (!isExist(this.myId.swiperContent_id)) {
        this.$changeOptionsEV("", "activeCol", false, null, {
          container_id: this.myId.container_id,
          rect_id: this.myId.rect_id
        }, true)
      }
    },
    elementMouseLeave(e) {
      if(this.isBigScreenPreview()) return
      if (this.isGridResizing) return
      // 如果当前页面有正在拖拽的元素禁止触发外层hover
      if ($(".dragging").length > 0 || $(".resizing").length > 0) return
      this.isHover = false
      this.mouseElement = ""
      // 鼠标移出元素 将父级元素的选中态加上
      if (this.layoutElement) this.layoutElement.classList.add("vdr_hover")
      if (this.layout) this.layout.classList.add("active")
      if (this.otherContent) this.otherContent.classList.add("hover")
      // 将单元格悬浮态加上
      let colId = this.myId.uid ? this.myId.uid : this.myId.swiperContent_id
      !this.layoutElement && this.$changeOptionsEV(colId, "activeCol", false, null, {
        container_id: this.myId.container_id,
        rect_id: this.myId.rect_id
      }, true)
      // 恢复当前栅格布局的悬浮状态
      if (this.waterGridItem) {
        this.waterGridItem?.classList.add("hover")
      }
      this.pageLayout = undefined
      this.layout = undefined
      this.otherContent = undefined
      this.waterGridItem = undefined
      e.target.classList.remove("vdr_hover")
    },
    // 设置外层页面布局的层级 当前的为最高
    setPageLayoutWrapZindex(show) {
      let parentNode = this.getParentNode(this.$el)
      if (parentNode.length === 0) {
        return
      }
      // 应要求，去掉选中 增高层级
      if (show) {
        parentNode[0].setAttribute("data-level", "top-level")
      } else {
        parentNode[0].removeAttribute("data-level")
      }
    },
    getParentNode(e, res = [], parentClass) {
      const parentNode = e.parentNode
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        if(!elClasslist ){
          return this.getParentNode(parentNode, res, parentClass)
        }
        if ([].find.call(elClasslist, it => it === "myContainer")) {
          return []
        } else if (parentClass && [].find.call(elClasslist, it => it === parentClass)) {
          res.push(parentNode)
        } else if ([].find.call(elClasslist, it => it === "page-layout-wrapper")) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNode(parentNode, res, parentClass)
        }
      } else {
        return res
      }
    },
    setLayoutColZindex(show) {
      let parentCol = this.getParentCol(this.$el)
      if (parentCol.length === 0) {
        return
      }
      if (show) {
        $(".layout-col[data-level='top-level']").removeAttr("data-level")
        parentCol[0].setAttribute("data-level", "top-level")
      } else {
        parentCol[0].removeAttribute("data-level")
      }
    },
    getParentCol(e, res = []) {
      const parentNode = e.parentNode
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        if ([].find.call(elClasslist, it => it === "myContainer")) {
          return []
        } else if ([].find.call(elClasslist, it => it === "layout-col")) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentCol(parentNode, res)
        }
      } else {
        return res
      }
    },
    // 元素按下
    elementDown(e) {
      if (this.request_prefix !== 'bigScreen') {
        if (isExist(this.ids?.rect_id)) {
          this.$store.commit("states/changeShowRightToolbarStatus", true)
        }
        console.log('this.options :>>',this.options);
      }
      if(this.shape === 'cxPageLayoutComponent'){
        return
      }
      //拖拽自由布局的单元格时 组件不动
      if (window.localStorage.getItem("dragLayoutCol")) return
      if (e instanceof MouseEvent && e.which !== 1 && e.which !==3) {
        return
      }

      const target = e.target || e.srcElement

      if (this.$el.contains(target)) {
        if (this.onDragStart(e) === false) {
          return
        }

        if (
          (this.dragHandle && !matchesSelectorToParentElements(target, this.dragHandle, this.$el)) ||
          (this.dragCancel && matchesSelectorToParentElements(target, this.dragCancel, this.$el))
        ) {
          this.dragging = false
          return
        }

        if (!this.enabled) {
          let tempSize = sessionStorage.getItem('tempSize')
          if(tempSize){
            let tempTimer = setTimeout(()=>{
              this.$emit("activated", this.elementInLayoutId, this.uid, this.elementName, this.direction, this.options)
              tempTimer = null
              sessionStorage.removeItem('tempSize')
            },10)
          }else{
            this.$emit("activated", this.elementInLayoutId, this.uid, this.elementName, this.direction, this.options)
          }
        }
        if (this.isDraggable) {
          // 直接点击激活组件，会被识别为拖拽，引起一系列问题。这里做一个延时判断，直接快速点击放开按钮，不再识别为拖拽状态
          this.preparingDag = true
          setTimeout(() => {
            if(this.preparingDag) {
              this.preparingDag = false
              this.dragging = true
            }
          }, 100)
        }

        this.mouseClickPosition.mouseX = e.touches ? e.touches[0].pageX : e.pageX
        this.mouseClickPosition.mouseY = e.touches ? e.touches[0].pageY : e.pageY

        this.mouseClickPosition.left = this.left
        this.mouseClickPosition.right = this.right
        this.mouseClickPosition.top = this.top
        this.mouseClickPosition.bottom = this.bottom
        this.mouseClickPosition.w = this.width
        this.mouseClickPosition.h = this.height

        this.bounds = this.calcDragLimits()
        this.handleUpdateJson()
        this.$emit("mouse-down", {
          left: e.offsetX + this.left,
          top: e.offsetY + this.top
        })

        addEvent(document.documentElement, eventsFor.move, this.move, false)
        addEvent(document.documentElement, eventsFor.stop, this.handleUp, false)
      }
      setTimeout(() => {// 选中通栏时点击元素会给通栏添加一个悬浮态 需要取消
        $($(this.$el).parents(".page-layout-wrapper.hover-active"))?.removeClass("hover-active")
        const waterGridItem = document.querySelector(".vue-grid-item.hover")
        if (waterGridItem) {
          waterGridItem?.classList.remove("hover")
        }
      },200)
    },
    // 计算移动范围
    calcDragLimits() {
      let currentWidth =
        this.options.widthType === "%" ? parseInt((this.computedWidth * this.parentW) / 100) : this.computedWidth
      let currentHeight =
        this.options.heightType === "%" ? parseInt((this.computedHeight * this.parentH) / 100) : this.computedHeight
      if (localStorage.getItem("asyncChangeComponent")) {
        return {
          minTop: this.top % this.grid[1],
          maxTop: Math.floor((this.parentHeight - currentHeight - this.top) / this.grid[1]) * this.grid[1] + this.top,
          minBottom: this.bottom % this.grid[1],
          maxBottom:
            Math.floor((this.parentHeight - currentHeight - this.bottom) / this.grid[1]) * this.grid[1] + this.bottom
        }
      } else {
        return {
          minLeft: this.left % this.grid[0],
          maxLeft: Math.floor((this.parentWidth - currentWidth - this.left) / this.grid[0]) * this.grid[0] + this.left,
          minRight: this.right % this.grid[0],
          maxRight:
            Math.floor((this.parentWidth - currentWidth - this.right) / this.grid[0]) * this.grid[0] + this.right,
          minTop: this.top % this.grid[1],
          maxTop: Math.floor((this.parentHeight - currentHeight - this.top) / this.grid[1]) * this.grid[1] + this.top,
          minBottom: this.bottom % this.grid[1],
          maxBottom:
            Math.floor((this.parentHeight - currentHeight - this.bottom) / this.grid[1]) * this.grid[1] + this.bottom
        }
      }
    },
    // 取消
    deselect(e) {
      if (e.target.classList.contains('size-control') || e.target.classList.contains('position-control')) return
      const target = e.target || e.srcElement
      const regex = new RegExp(this.className + "-([trmbl]{2})", "")
      if (!this.checkDeselectEl(target) && !this.$el.contains(target) && !regex.test(target.className)) {
        if (this.enabled && !this.preventDeactivation) {
          this.$emit("deactivated", this.elementInLayoutId, this.uid, this.elementName, this.direction)
        }

        removeEvent(document.documentElement, eventsFor.move, this.handleResize, false)
      }

      this.resetBoundsAndMouseState()
    },
    checkDeselectEl(el) {
      // 弹窗内部操作不取消当前选中状态, 顶部操作栏按钮点击不取消选中状态, 数据源弹窗内部点击不取消选中状态
      const classNames = [
        "el-color-svpanel__black",
        "select-tag",
        "el-select-dropdown__item",
        "el-dropdown-menu",
        "icon-portal-page-template",
        "icon-portal-setting1",
        "control-button",
        "right-menu-container",
        "el-message-box__wrapper",
        "el-drawer__container",
        "el-dialog__wrapper"
      ]
      const innerTexts = ["确定"]
      return (
        classNames.some(it => el?.className?.includes(it) && !el?.className?.includes("control-button-device")) ||
        el.innerText.includes(innerTexts.join()) ||
        $(el).parents(".el-dialog__wrapper")?.length ||
        $(el).parents(".el-message-box__wrapper")?.length ||
        $(el).parents(".rightMenuDialog")?.length ||
        $(el).parent().hasClass("el-select-dropdown__item") ||
        $(el).parents('.left-home')?.length ||
        $(el).parents(".el-color-picker__panel")?.length ||
        $(el).parents(".bg-set-dialog")?.length ||
        $(el).hasClass("fold-btn icon-portal-arrow-right") ||
        $(el).parents("#dataSetting")?.length ||
        $(el).parents(".right-toolbar")?.length
      )
    },
    // 控制柄触摸按下
    handleTouchDown(handle, e) {
      if (this.isBigScreenPreview()) return
      eventsFor = events.touch

      this.handleDown(handle, e)
    },
    // 控制柄按下
    handleDown(handle, e) {
      if (this.isBigScreenPreview()) return
      this.before = this.getQuickShot()
      if (e instanceof MouseEvent && e.which !== 1) {
        return
      }

      if (this.onResizeStart(handle, e) === false) {
        return
      }
      if (e.stopPropagation) e.stopPropagation()

      // Here we avoid a dangerous recursion by faking
      // corner handles as middle handles
      if (this.lockAspectRatio && !handle.includes("m")) {
        this.handle = "m" + handle.substring(1)
      } else {
        this.handle = handle
      }

      this.resizing = true

      this.draggingOrResizing = true

      this.mouseClickPosition.mouseX = e.touches ? e.touches[0].pageX : e.pageX
      this.mouseClickPosition.mouseY = e.touches ? e.touches[0].pageY : e.pageY
      this.mouseClickPosition.left = this.left
      this.mouseClickPosition.right = this.right
      this.mouseClickPosition.top = this.top
      this.mouseClickPosition.bottom = this.bottom
      this.mouseClickPosition.w = this.width
      this.mouseClickPosition.h = this.height
      this.bounds = this.calcResizeLimits()
      this.handleUpdateJson()
      addEvent(document.documentElement, eventsFor.move, this.handleResize)
      addEvent(document.documentElement, eventsFor.stop, this.handleUp)
    },
    // 计算调整大小范围
    calcResizeLimits() {
      let minW = this.minW
      let minH = this.minH
      let maxW = this.maxW
      let maxH = this.maxH

      const aspectFactor = this.aspectFactor
      const [gridX, gridY] = this.grid
      const width = this.width
      const height = this.height
      const left = this.left
      const top = this.top
      const right = this.right
      const bottom = this.bottom

      if (this.lockAspectRatio) {
        if (minW / minH > aspectFactor) {
          minH = minW / aspectFactor
        } else {
          minW = aspectFactor * minH
        }

        if (maxW && maxH) {
          maxW = Math.min(maxW, aspectFactor * maxH)
          maxH = Math.min(maxH, maxW / aspectFactor)
        } else if (maxW) {
          maxH = maxW / aspectFactor
        } else if (maxH) {
          maxW = aspectFactor * maxH
        }
      }

      maxW = maxW - (maxW % gridX)
      maxH = maxH - (maxH % gridY)

      const limits = {
        minLeft: null,
        maxLeft: null,
        minTop: null,
        maxTop: null,
        minRight: null,
        maxRight: null,
        minBottom: null,
        maxBottom: null
      }

      if (this.parent) {
        limits.minLeft = left % gridX
        limits.maxLeft = left + Math.floor((width - minW) / gridX) * gridX
        limits.minTop = top % gridY
        limits.maxTop = top + Math.floor((height - minH) / gridY) * gridY
        limits.minRight = right % gridX
        limits.maxRight = right + Math.floor((width - minW) / gridX) * gridX
        limits.minBottom = bottom % gridY
        limits.maxBottom = bottom + Math.floor((height - minH) / gridY) * gridY

        if (maxW) {
          limits.minLeft = Math.max(limits.minLeft, this.parentWidth - right - maxW)
          limits.minRight = Math.max(limits.minRight, this.parentWidth - left - maxW)
        }

        if (maxH) {
          limits.minTop = Math.max(limits.minTop, this.parentHeight - bottom - maxH)
          limits.minBottom = Math.max(limits.minBottom, this.parentHeight - top - maxH)
        }

        if (this.lockAspectRatio) {
          limits.minLeft = Math.max(limits.minLeft, left - top * aspectFactor)
          limits.minTop = Math.max(limits.minTop, top - left / aspectFactor)
          limits.minRight = Math.max(limits.minRight, right - bottom * aspectFactor)
          limits.minBottom = Math.max(limits.minBottom, bottom - right / aspectFactor)
        }
      } else {
        limits.minLeft = null
        limits.maxLeft = left + Math.floor((width - minW) / gridX) * gridX
        limits.minTop = null
        limits.maxTop = top + Math.floor((height - minH) / gridY) * gridY
        limits.minRight = null
        limits.maxRight = right + Math.floor((width - minW) / gridX) * gridX
        limits.minBottom = null
        limits.maxBottom = bottom + Math.floor((height - minH) / gridY) * gridY

        if (maxW) {
          limits.minLeft = -(right + maxW)
          limits.minRight = -(left + maxW)
        }

        if (maxH) {
          limits.minTop = -(bottom + maxH)
          limits.minBottom = -(top + maxH)
        }

        if (this.lockAspectRatio && maxW && maxH) {
          limits.minLeft = Math.min(limits.minLeft, -(right + maxW))
          limits.minTop = Math.min(limits.minTop, -(maxH + bottom))
          limits.minRight = Math.min(limits.minRight, -left - maxW)
          limits.minBottom = Math.min(limits.minBottom, -top - maxH)
        }
      }

      return limits
    },
    // 移动
    move(ev) {
      if (this.resizing) {
        this.handleResize(ev)
      } else if (this.dragging) {
        this.handleDrag(ev)
      }
    },
    // 获取父级的dom元素 用于显示当前元素的父元素边框
    getParentNode1(handleInfo) {
      let parentNode
      switch (handleInfo.shape) {
        case "colsComponent":
          parentNode = $(`#${handleInfo.ids.uid}`)
          break
        case "cxPageLayoutCell":
          parentNode =
            handleInfo.ids.pageLayoutId.length === 1
              ? $(`.pageLayout_id_${handleInfo.ids.pageLayoutId}`)
              : $(`#layout_${handleInfo.ids.pageLayoutId}`)
          break
        case "cxPageLayout":
          parentNode = $(`.pageLayout_id_${handleInfo.ids.pageLayoutId}`)
          break
        case "page":
          parentNode = $(`#container_${handleInfo.ids.container_id}`)
          break
        case "cxPageLayoutComponentCell":
          parentNode = $(`#rect_id_${handleInfo.ids.rect_id}_layout_${handleInfo.ids.pageLayoutId}`)
          break
        default:
          if (isExist(this.myId.directionIndex)) {
            // 四边栏内的元素 父元素为四边栏
            parentNode = $(
              `.container_id_${this.myId.container_id}-rect_id_${this.myId.rect_id}-directionIndex_${this.myId.directionIndex}-elementInLayoutId_${this.myId.elementInLayoutId}`
            ).parent(".other_content")
          }
          if (handleInfo.ids.uid) {
            parentNode = $(
              `.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}-uid_${handleInfo.ids.uid}-elementInLayoutId_${handleInfo.ids.elementInLayoutId}`
            )
          } else if (handleInfo.ids.elementInAutoLayoutId !== undefined) {
            parentNode = $(`.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}-elementInAutoLayoutId_${handleInfo.ids.elementInAutoLayoutId}-path_${handleInfo.ids.path ? handleInfo.ids.path.join('') : handleInfo.ids.path}`)
          } else {
            parentNode = $(`.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}`)
          }
      }
      return parentNode
    },
    // 元素移动
    handleDrag: _throttle(async function (e) {
      if(this.isGoTop) {
        return
      }
      // 给父级元素添加边框 边框内为可移动范围
      if (this.handleList && this.handleList.length > 1) {
        let parentNode = this.getParentNode1(this.handleList[1])
        let waterFlow = false //是否是栅格布局
        if (this.handleList[1]?.shape === "cxPageLayoutCell" || this.handleList[1]?.shape === "cxPageLayoutComponentCell") {
          let cell =  this.getAttrById(this.$store.state[this.request_prefix], this.handleList[1].ids, "pageLayout")
          waterFlow = cell.options.waterFlow
        }
        !waterFlow && parentNode && parentNode.addClass("hover-active")
        this.waterGridItem = document.querySelector(".vue-grid-item.grid-hover")
        if (!waterFlow && this.waterGridItem) {
          this.waterGridItem?.classList.remove("grid-hover")
        }
      }
      const axis = this.axis
      const grid = this.grid
      const bounds = this.bounds
      let offsetLeft = 0, offsetTop = 0
      let zoom = this.zoom || 1
      const vdr = $(e.target).hasClass("vdr") ? e.target : this.getParentNode(e.target, [], "vdr")[0]
      if (this.options.isQuickSite) {
        // 元素移动取消快捷定位
        this.$changeOptionsEV(false, "isQuickSite", false, null, this.myId, true)
        const offset = this.getVdrOffset(e)
        offsetLeft = offset.offsetLeft
        offsetTop = offset.offsetTop
      } else {
        if (this.options.leftType === "%") {
          offsetLeft = vdr && vdr.offsetLeft > 0 ? vdr.offsetLeft : 0
        }
        if (this.options.topType === "%") {
          offsetTop = vdr && vdr.offsetTop > 0 ? vdr.offsetTop : 0
        }
      }
      if (this.options.leftType === "%") {
        this.mouseClickPosition.left = offsetLeft / zoom
        this.$changeOptionsEV("px", "leftType", false, null, this.myId, true)
      }
      if (this.options.topType === "%") {
        this.mouseClickPosition.top = offsetTop / zoom
        this.$changeOptionsEV("px", "topType", false, null, this.myId, true)
      }
      const mouseClickPosition = this.mouseClickPosition

      let tmpDeltaX = axis && axis !== "y" ? mouseClickPosition.mouseX - (e.touches ? e.touches[0].pageX : e.pageX) : 0
      let tmpDeltaY = axis && axis !== "x" ? mouseClickPosition.mouseY - (e.touches ? e.touches[0].pageY : e.pageY) : 0
      const [deltaX, deltaY] = snapToGrid(grid, tmpDeltaX, tmpDeltaY, this.zoom)

      const left = restrictToBounds(mouseClickPosition.left - deltaX, bounds.minLeft, bounds.maxLeft)
      const top = restrictToBounds(mouseClickPosition.top - deltaY, bounds.minTop, bounds.maxTop)
      if (this.onDrag(left, top) === false) {
        return
      }
      const right = restrictToBounds(mouseClickPosition.right + deltaX, bounds.minRight, bounds.maxRight)
      const bottom = restrictToBounds(mouseClickPosition.bottom + deltaY, bounds.minBottom, bounds.maxBottom)
      this.left = left
      this.top = top
      this.right = right
      this.bottom = bottom
      this.draggingOrResizing = true
      await this.snapCheck()
      if (isExist(this.elementInAutoLayoutId)) {
        this.$emit("dragging", this.rect, this.elementInAutoLayoutId, this.options.path, e)
      } else if (this.myId.elementInDataGridId) {
        this.$emit("dragging", this.rect, this.myId.elementInDataGridId, e)
      } else {
        this.$emit("dragging", this.rect, this.elementInLayoutId, this.uid, this.direction, e)
      }
    }, 50),
    moveHorizontally(val) {
      const [deltaX, _] = snapToGrid(this.grid, val, this.top, this.scale)
      const left = restrictToBounds(deltaX, this.bounds.minLeft, this.options?.leftType === "%" ? 100 : this.bounds.maxLeft)
      this.left = left
      this.right = this.parentWidth - this.width - left
    },
    moveVertically(val) {
      const [_, deltaY] = snapToGrid(this.grid, this.left, val, this.scale)
      // 当选择百分比定位时，父容器高度很小，会获取一个较小的最大值，导致点击组件是定位会改变
      const top = restrictToBounds(deltaY, this.bounds.minTop, this.options?.topType === "%" ? 100 : this.bounds.maxTop)
      this.top = top
      this.bottom = this.parentHeight - this.height - top
    },
    handleUpdateJson() {
      let status = this.$store.state.states.showLeftMenu
      this.$store.commit("states/changeShowLeftMenuStatus", !status)
      // }
    },
    // 控制柄移动
    handleResize: _throttle(async function (e) {
      let left = this.left
      let top = this.top
      let right = this.right
      let bottom = this.bottom
      const mouseClickPosition = this.mouseClickPosition
      const aspectFactor = this.aspectFactor

      let tmpDeltaX = mouseClickPosition.mouseX - (e.touches ? e.touches[0].pageX : e.pageX)
      let tmpDeltaY = mouseClickPosition.mouseY - (e.touches ? e.touches[0].pageY : e.pageY)
      if (!this.widthTouched && tmpDeltaX) {
        this.widthTouched = true
      }
      if (!this.heightTouched && tmpDeltaY) {
        this.heightTouched = true
      }
      const [deltaX, deltaY] = snapToGrid(this.grid, tmpDeltaX, tmpDeltaY, this.zoom)
      let parentOptions = this.getParentOptions
      let heightAuto = parentOptions?.showRowColLayout && parentOptions?.heightType === "自动" || false
      let widthAuto = parentOptions?.showRowColLayout && parentOptions?.widthType === "自动" || false
      let widthFill = (parentOptions?.showRowColLayout) && (this.options?.widthType === "%" || this.options?.widthType === "自动") || false
      let heightFill = (parentOptions?.showRowColLayout) && (this.options?.heightType === "%" || this.options?.heightType === "自动") || false
      const [width1, height1] = getComputedSize(this.$el)
      if (this.handle.includes("b")) {
        if (this.options.heightType === "%") {
          this.bottom = this.parentHeight - height1 - this.top
          this.mouseClickPosition.bottom = this.bottom
        }
        // 不进行上下边距检测，最大值等于父级高度
        if (parentOptions?.isShowLayoutCanvas) {
          this.bounds.maxBottom = this.parentHeight
          if (this.bottom === 0 || this.bottom < 0) {// 拖动到最下边了 高度还是不等于父级高度
            this.bounds.minBottom = computeHeight(this.parentHeight, top, bottom) - this.parentHeight
          }
        }
        bottom =
          this.options && this.options.isNoConflictCheck || heightAuto || this.options.isQuickSite
            ? mouseClickPosition.bottom + deltaY
            : restrictToBounds(mouseClickPosition.bottom + deltaY, this.bounds.minBottom, this.bounds.maxBottom)
        if (this.lockAspectRatio && this.resizingOnY && this.options.widthType !== "%") {
          right = this.right - (this.bottom - bottom) * aspectFactor
        }
        // 高度充满或者自适应，拖动辅助线时需要自动转换为固定高度
        if (heightFill || this.options.heightType === "%") {
          this.$changeOptionsEV("px", "heightType", false, null, this.myId, true)
        }
      } else if (this.handle.includes("t")) {
        if (this.options.widthType === "%") {
          this.bottom = this.parentHeight - height1 - this.top
          this.mouseClickPosition.bottom = this.bottom
          bottom = this.bottom
        }
        top =
          this.options && this.options.isNoConflictCheck || heightAuto || this.options.isQuickSite
            ? mouseClickPosition.top - deltaY
            : restrictToBounds(mouseClickPosition.top - deltaY, this.bounds.minTop, this.bounds.maxTop)
        if (this.lockAspectRatio && this.resizingOnY) {
          left = this.left - (this.top - top) * aspectFactor
        }
        // 高度充满或者自适应，拖动辅助线时需要自动转换为固定高度
        if (heightFill || this.options.heightType === "%") {
          this.$changeOptionsEV("px", "heightType", false, null, this.myId, true)
        }
      }
      if (this.handle.includes("r")) {
        if (this.options.widthType === "%") {
          this.right = this.parentWidth - width1 - this.left
          this.mouseClickPosition.right = this.right
        }
        right =
          this.options && this.options.isNoConflictCheck || widthAuto || this.options.isQuickSite
            ? mouseClickPosition.right + deltaX
            : restrictToBounds(mouseClickPosition.right + deltaX, this.bounds.minRight, this.bounds.maxRight)
        if (this.lockAspectRatio && this.resizingOnX && this.options.heightType !== "%") {
          bottom = this.bottom - (this.right - right) / aspectFactor
        }
        // 宽度充满或者自适应，拖动辅助线时需要自动转换为固定宽度
        if (widthFill || this.options.widthType === "%") {
          this.$changeOptionsEV("px", "widthType", false, null, this.myId, true)
        }
      } else if (this.handle.includes("l")) {
        if (this.options.widthType === "%") {
          this.right = this.parentWidth - width1 - this.left
          this.mouseClickPosition.right = this.right
          right = this.right
        }
        left =
          this.options && this.options.isNoConflictCheck || widthAuto || this.options.isQuickSite
            ? mouseClickPosition.left - deltaX
            : restrictToBounds(mouseClickPosition.left - deltaX, this.bounds.minLeft, this.bounds.maxLeft)
        if (this.lockAspectRatio && this.resizingOnX && this.options.heightType !== "%") {
          top = this.top - (this.left - left) / aspectFactor
        }
        // 宽度充满或者自适应，拖动辅助线时需要自动转换为固定宽度
        if (widthFill || this.options.widthType === "%") {
          this.$changeOptionsEV("px", "widthType", false, null, this.myId, true)
        }
      }
      const width = computeWidth(this.parentWidth, left, right)
      const height = computeHeight(this.parentHeight, top, bottom)
      if (this.onResize(this.handle, left, top, width, height) === false) {
        return
      }
      this.left = left
      this.right = right
      if (this.handle.includes("l") || this.handle.includes("r")) {
        this.width = width > 1 ? width : 1 //最小不能小于1
        this.width = this.options.widthType === "%" && this.width > 100 ? 100 : this.width //百分比最大不能大于100
      }
      this.top = top
      this.bottom = bottom
      if (this.handle.includes("t") || this.handle.includes("b")) {
        this.height = height > 1 ? height : 1 //最小不能小于1
        this.height = this.options.heightType === "%" && this.height > 100 ? 100 : this.height //百分比最大不能大于100
      }
      // await this.snapCheck()
      if (isExist(this.elementInAutoLayoutId)) {
        this.$emit("resizing", this.rect, this.elementInAutoLayoutId, this.options.path)
      } else if (this.myId.elementInDataGridId) {
        console.log("resizing>>>", this.rect)
        this.$emit("resizing", this.rect, this.myId.elementInDataGridId)
      } else {
        this.$emit("resizing", this.rect, this.elementInLayoutId, this.uid, this.direction)
      }
    }, 50),
    changeWidth(val) {
      //自适应的时候不需要考虑组件超出画布的场景,因为要计算当前组件在pc端的真实大小
      if (localStorage.getItem("asyncChangeComponent")) {
        this.width = val
        return
      }
      let parentOptions = this.getParentOptions
      if (this.options.widthType === "%") {
        if (!parentOptions?.showRowColLayout) {
          val = this.parentWidth * (val / 100)
        }
      }
      const [newWidth, _] = snapToGrid(this.grid, val, 0, this.scale)
      // let right = restrictToBounds(this.parentWidth - newWidth - this.left, this.bounds.minRight, this.bounds.maxRight)
      let right = restrictToBounds(
        this.parentWidth - newWidth - this.left,
        this.bounds.minRight,
        this.parentWidth - this.left
      )
      let bottom = this.bottom
      if (this.lockAspectRatio) {
        bottom = this.bottom - (this.right - right) / this.aspectFactor
      }
      const width =
        this.options.widthType === "%"
          ? val
          : Math.min(
              computeWidth(this.parentWidth, this.options.isQuickSite ? 0 : this.left, right),
              this.options.width
            )
      const height = this.height // computeHeight(this.parentHeight, this.top, bottom)
      this.right = right
      this.bottom = bottom
      this.width = this.options.widthType === "%" ? Math.min(Math.floor((width / this.parentWidth) * 100), 100) : width
      this.height = height
    },
    changeHeight(val) {
      //自适应的时候不需要考虑组件超出画布的场景,因为要计算当前组件在pc端的真实大小
      if (localStorage.getItem("asyncChangeComponent")) {
        this.height = val
        return
      }
      // 所在自动布局高度自适应时，不需要考虑超出的场景
      let parentOptions = this.getParentOptions
      if (parentOptions?.showRowColLayout && parentOptions?.height === "auto") {
        this.height = val
        return
      }
      if (this.options.heightType === "%") {
        if (!parentOptions?.showRowColLayout) {
          val = this.parentHeight * (val / 100)
        }
      }
      const [_, newHeight] = snapToGrid(this.grid, 0, val, this.scale)
      let bottom = restrictToBounds(
        this.parentHeight - newHeight - this.top,
        this.bounds.minBottom,
        this.parentHeight - this.top
      )
      let right = this.right
      if (this.lockAspectRatio) {
        right = this.right - (this.bottom - bottom) * this.aspectFactor
      }
      const width = this.width // computeWidth(this.parentWidth, this.left, right)
      // 自动布局下的组件top bottom会影响计算最大高度
      const height =
        this.options.heightType === "%"
          ? Math.min(Math.floor((val / this.parentHeight) * 100), 100)
          : parentOptions?.showRowColLayout ? Math.min(this.parentHeight, this.options.height) : Math.min(
              computeHeight(this.parentHeight, this.options.isQuickSite ? 0 : this.top, bottom),
              this.options.height
            )
      this.right = right
      this.bottom = bottom
      this.width = width
      this.height = height
    },
    // 保存元素的真实尺寸
    changeBoundSize(type) {
      if (this.myId.hasOwnProperty("rect_id") && (this.getParentOptions?.showRowColLayout)) {// 组件在自动布局中
        let path = `${this.myId.path ? this.myId.path.join('') : this.myId.path}`
        let className = this.myId.uid ? `container_id_${this.myId.container_id}-rect_id_${this.myId.rect_id}-uid_${this.myId.uid}-elementInLayoutId_${this.myId.elementInLayoutId}-elementInAutoLayoutId_${this.myId.elementInAutoLayoutId}-path_${path}` : `container_id_${this.myId.container_id}-rect_id_${this.myId.rect_id}-elementInAutoLayoutId_${this.myId.elementInAutoLayoutId}-path_${path}`
        if (!this.myId.hasOwnProperty("elementInAutoLayoutId")) {
          className = `container_id_${this.myId.container_id}-rect_id_${this.myId.rect_id}`
        }
        let element = document.getElementsByClassName(className)[0]
        setTimeout(() => {// 需要加延时，刚修改后获取的值还是之前的
          let rect = element?.getBoundingClientRect()
          if (rect) {
            let width = rect.width
            let height = rect.height
            if (type === "width" || type === "all") {
              this.$changeOptionsEV(width, "boundWidth", false, null, this.myId, true)
              if (this.options.widthType === "%" || this.options.widthType === "自动") {// 重新计算距左边和右边的距离
                this.changeWidth(width)
              }
            }
            if (type === "height" || type === "all") {
              this.$changeOptionsEV(height, "boundHeight", false, null, this.myId, true)
              if (this.options.heightType === "%" || this.options.heightType === "自动") {// 重新计算距顶部和底部的距离
                this.changeHeight(height)
              }
            }
          }
        }, 500);
      }
    },
    // 从控制柄松开
    async handleUp(e) {
      if(this.shape === 'cxPageLayoutComponent'){
        return
      }
      if (this.handleList && this.handleList.length > 1) {
        let parentNode = this.getParentNode1(this.handleList[1])
        parentNode && parentNode.removeClass("hover-active")
      }
      this.handle = null
      this.draggingOrResizing = false
      this.$emit("clicked", e, this.elementInLayoutId, this.uid, this.$el)
      // 初始化辅助线数据
      const temArr = new Array(3).fill({
        display: false,
        position: "",
        origin: "",
        lineLength: "",
        cw: 0, //当前组件宽度
        ch: 0, //当前组件高度
        w: 0, //与当前组件对齐的组件的宽度
        h: 0 //与当前组件对齐的组件的高度
      })
      const refLine = { vLine: [], hLine: [] }
      for (let i in refLine) {
        refLine[i] = JSON.parse(JSON.stringify(temArr))
      }
      const showRowColLayout = this.getParentOptions?.showRowColLayout
      if (this.resizing) {
        this.resizing = false
        await this.conflictCheck()
        this.$emit("refLineParams", refLine)
        if (isExist(this.elementInAutoLayoutId)) {
          this.$emit("resizeStop", this.rect, this.elementInAutoLayoutId, this.options.path, e)
        } else if (this.myId.elementInDataGridId) {
          this.$emit("resizeStop", this.rect, this.myId.elementInDataGridId)
        } else {
          this.$emit("resizeStop", this.rect, this.elementInLayoutId, this.uid, this.direction)
        }
        const data = this.getQuickShot()
        if (!isEqual(this.before, data) && !showRowColLayout) {
          this.$addHistory({
            type: "update",
            stateType: "updateProperty",
            payload: {
              ...this.myId,
              option_name: ["width", "height", "top", "left"],
              option_val: []
            },
            before: this.before,
            data,
            ignoreRecord: true
          })
        }
      }
      if(this.preparingDag) {
        this.preparingDag = false
      } else {
        if (this.dragging) {
          this.dragging = false
          await this.conflictCheck()
          this.$emit("refLineParams", refLine)
          if (isExist(this.elementInAutoLayoutId)) {
            this.$emit("dragStop", this.rect, this.elementInAutoLayoutId, this.options.path, e)
          } else if (this.myId.elementInDataGridId) {
            this.$emit("dragStop", this.rect, this.myId.elementInDataGridId, e)
          } else {
            this.$emit("dragStop", this.rect, this.elementInLayoutId, this.uid, this.direction, e)
          }
          const data = this.getQuickShot()
          if (!isEqual(this.before, data) && !showRowColLayout) {
            this.$addHistory({
              type: "update",
              stateType: "updateProperty",
              payload: {
                ...this.myId,
                option_name: ["width", "height", "top", "left"],
                option_val: []
              },
              before: this.before,
              data,
              ignoreRecord: true
            })
          }
        }
      }
      this.resetBoundsAndMouseState()
      removeEvent(document.documentElement, eventsFor.move, this.handleResize)
    },
    getVdrOffset(e) {
      const vdr = $(e.target).hasClass("vdr") ? e.target : this.getParentNode(e.target, [], "vdr")[0]
      let offsetLeft = 0,offsetTop = 0
      if (vdr) {
        const vdrClient = vdr.getBoundingClientRect()
        const parent = vdr ? vdr.parentNode : null
        const parentClient = parent.getBoundingClientRect()
        offsetLeft = vdrClient.left - parentClient.left > 0 ? vdrClient.left - parentClient.left : 0
        offsetTop = vdrClient.top - parentClient.top > 0 ? vdrClient.top - parentClient.top : 0
      }
      return {vdr, offsetLeft, offsetTop}
    },
    // 修改偏移值
    updateOffset() {
      if (!this.startDragVdr?.classList?.contains('vdr')) return
      const vdrClient = this.startDragVdr.getBoundingClientRect()
      const parent = this.startDragVdr ? this.startDragVdr.parentNode : null
      if (!parent) return
      const parentClient = parent.getBoundingClientRect()
      const offsetLeft = vdrClient.left - parentClient.left > 0 ? vdrClient.left - parentClient.left : 0
      const offsetTop = vdrClient.top - parentClient.top > 0 ? vdrClient.top - parentClient.top : 0
      console.log('当前top',offsetTop, offsetLeft);
      console.log('this.positionLeft,positionTop :>>',this.positionLeft,this.positionTop);
      console.log('点击时Top :>>', this.startOffsetTop);
      const offsetX = parseInt(offsetLeft - this.startOffsetLeft) // 当前元素位置减去开始拖拽时元素位置
      const offsetY = parseInt(offsetTop - this.startOffsetTop)
      this.left = this.positionLeft // 重置为起始时的定位值
      this.top = this.positionTop
      let offset = Array.isArray(this.options.offset) ? this.options.offset : [0,0,0,0]
      if (offsetX > 0) {// 往右移动
        if (offset[1]) offset[1] -= offsetX
        else offset[3] += offsetX
      } else {// 往左移动
        if (offset[3]) offset[3] += offsetX
        else offset[1] -= offsetX
      }
      if (offsetY > 0) {// 往下移动
        if (offset[2]) offset[2] -= offsetY
        else offset[0] += offsetY
      } else {// 往上移动
        if (offset[0]) offset[0] += offsetY
        else offset[2] -= offsetY
      }
      if (offset[1] < 0) {
        offset[3] = Math.abs(offset[1])
        offset[1] = 0
      }
      if (offset[3] < 0) {
        offset[1] = Math.abs(offset[3])
        offset[3] = 0
      }
      if (offset[0] < 0) {
        offset[2] = Math.abs(offset[0])
        offset[0] = 0
      }
      if (offset[2] < 0) {
        offset[0] = Math.abs(offset[2])
        offset[2] = 0
      }
      console.log('offset :>>',offset);
      this.$changeOptionsEV(offset, "offset", false, null, this.myId, true) // 修改偏移值
      this.$changeOptionsEV("%", "topType", false, null, this.myId, true)
      this.$changeOptionsEV("%", "leftType", false, null, this.myId, true)
    },
    // 新增方法 ↓↓↓
    // 设置属性
    settingAttribute() {
      // 设置冲突检测
      this.$el.setAttribute("data-is-check", `${this.isConflictCheck}`)
      // 设置对齐元素
      this.$el.setAttribute("data-is-snap", `${this.snap}`)
    },
    // //删除事件触发
    del() {
      // 之前的删除操作有问题，现在将方法集中化
      this.$confirm("确认删除吗？", "", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
        iconClass: "bigScreen_confirm_icon el-icon-warning",
        cancelButtonClass: "bigScreen_confirm_cancel_button",
        confirmButtonClass: "bigScreen_confirm_button",
        customClass: "bigScreen_confirm custom_warning_dialog"
      })
        .then(() => {
          this.$addHistory({
            type: "delete",
            stateType: "deleteElement",
            payload: { ...this.myId }
          })
          this.$store.dispatch(this.request_prefix + "/deleteElement", { ...this.myId })
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "删除成功"
          })
          // 栅格内的复杂组件删除自身时，尝试同时删掉空栅格
          if (this.isGridItem && this.$refs?.vueDragResizable?.classList?.contains('is_full_rect')) {
            this.$emit('delGridItem')
          }
        })
        .catch(() => {
        })
    },
    changeSwiperMode() {
      this.$emit("swiperModeChange", !this.swiperMode)
    },
    reRender() {
      this.$emit("reRender")
    },
    // 冲突检测
    conflictCheck() {
      if (Number.isNaN(this.width) || Number.isNaN(this.height)) {
        return
      }
      const top = this.top
      const left = this.left
      const width = this.width
      const height = this.height
      if (this.isConflictCheck) {
        const nodes = this.$el.parentNode.childNodes // 获取当前父节点下所有子节点
        for (let item of nodes) {
          if (
            item.className !== undefined &&
            !item.className.includes(this.classNameActive) &&
            item.getAttribute("data-is-check") !== null &&
            item.getAttribute("data-is-check") !== "false"
          ) {
            const tw = item.offsetWidth
            const th = item.offsetHeight
            // 正则获取left与right
            let [tl, tt] = this.formatPositionVal(item.style.transform)

            // 左上角与右下角重叠
            const tfAndBr =
              (top >= tt && left >= tl && tt + th > top && tl + tw > left) ||
              (top <= tt && left < tl && top + height > tt && left + width > tl)
            // 右上角与左下角重叠
            const brAndTf =
              (left <= tl && top >= tt && left + width > tl && top < tt + th) ||
              (top < tt && left > tl && top + height > tt && left < tl + tw)
            // 下边与上边重叠
            const bAndT =
              (top <= tt && left >= tl && top + height > tt && left < tl + tw) ||
              (top >= tt && left <= tl && top < tt + th && left > tl + tw)
            // 上边与下边重叠（宽度不一样）
            const tAndB =
              (top <= tt && left >= tl && top + height > tt && left < tl + tw) ||
              (top >= tt && left <= tl && top < tt + th && left > tl + tw)
            // 左边与右边重叠
            const lAndR =
              (left >= tl && top >= tt && left < tl + tw && top < tt + th) ||
              (top > tt && left <= tl && left + width > tl && top < tt + th)
            // 左边与右边重叠（高度不一样）
            const rAndL =
              (top <= tt && left >= tl && top + height > tt && left < tl + tw) ||
              (top >= tt && left <= tl && top < tt + th && left + width > tl)
            // 如果冲突，就将回退到移动前的位置
            if (tfAndBr || brAndTf || bAndT || tAndB || lAndR || rAndL) {
              this.top = this.mouseClickPosition.top
              this.left = this.mouseClickPosition.left
              this.right = this.mouseClickPosition.right
              this.bottom = this.mouseClickPosition.bottom
              this.width = this.mouseClickPosition.w
              this.height = this.mouseClickPosition.h
            }
          }
        }
      }
    },
    // 检测对齐元素
    async snapCheck() {
      if (Number.isNaN(this.width) || Number.isNaN(this.height)) {
        return
      }
      let width = this.width
      let height = this.height
      if (this.snap) {
        let activeLeft = this.left
        let activeRight = this.left + width
        let activeTop = this.top
        let activeBottom = this.top + height

        // 初始化辅助线数据
        const temArr = new Array(3).fill({
          display: false,
          position: "",
          origin: "",
          lineLength: "",
          cw: 0, //当前组件宽度
          ch: 0, //当前组件高度
          w: 0, //与当前组件对齐的组件的宽度
          h: 0 //与当前组件对齐的组件的高度
        })
        const refLine = { vLine: [], hLine: [] }
        for (let i in refLine) {
          refLine[i] = JSON.parse(JSON.stringify(temArr))
        }
        // 获取当前父节点下所有子节点
        let childNodes = this.$el.parentNode.childNodes
        let nodes = []
        // 排除掉不进行对比的元素
        for (let k = 0; k < childNodes.length; k++) {
          if (childNodes[k].classList?.contains("draggable")) {
            nodes.push(childNodes[k])
          }
        }
        let tem = {
          value: { x: [[], [], []], y: [[], [], []] },
          display: [],
          position: []
        }
        const { groupWidth, groupHeight, groupLeft, groupTop, bln } = await this.getActiveAll(nodes)
        if (!bln) {
          width = groupWidth
          height = groupHeight
          activeLeft = groupLeft
          activeRight = groupLeft + groupWidth
          activeTop = groupTop
          activeBottom = groupTop + groupHeight
        }
        for (let item of nodes) {
          // 兄弟元素进行了快捷定位和百分比的情况，不进行比较
          if (!item.style || item.style.marginLeft || item.style.transform.indexOf("%") > -1) {
            return
          }
          if (
            item.className !== undefined &&
            !item.className.includes(this.classNameActive) &&
            item.getAttribute("data-is-snap") !== null &&
            item.getAttribute("data-is-snap") !== "false"
          ) {
            const w = item.offsetWidth
            const h = item.offsetHeight
            // const [l, t] = this.formatPositionVal(item)
            const [l, t] = this.formatPositionVal(item.style.transform)
            // const [l, t] = [this.x, this.y]
            const r = l + w // 对齐目标right
            const b = t + h // 对齐目标的bottom
            const hc = Math.abs(activeTop + height / 2 - (t + h / 2)) <= this.snapTolerance // 水平中线
            const vc = Math.abs(activeLeft + width / 2 - (l + w / 2)) <= this.snapTolerance // 垂直中线

            const ts = Math.abs(t - activeBottom) <= this.snapTolerance // 从上到下
            const TS = Math.abs(b - activeBottom) <= this.snapTolerance // 从上到下
            const bs = Math.abs(t - activeTop) <= this.snapTolerance // 从下到上
            const BS = Math.abs(b - activeTop) <= this.snapTolerance // 从下到上

            const ls = Math.abs(l - activeRight) <= this.snapTolerance // 外左
            const LS = Math.abs(r - activeRight) <= this.snapTolerance // 外左
            const rs = Math.abs(l - activeLeft) <= this.snapTolerance // 外右
            const RS = Math.abs(r - activeLeft) <= this.snapTolerance // 外右

            tem["display"] = [ts, TS, bs, BS, hc, hc, ls, LS, rs, RS, vc, vc]
            tem["position"] = [t, b, t, b, t + h / 2, t + h / 2, l, r, l, r, l + w / 2, l + w / 2]

            if (ts) {
              if (bln && this.snapWithAdsorbent) {
                this.top = t - height
                this.bottom = this.parentHeight - this.top - height
              }
              tem.value.y[0].push(l, r, activeLeft, activeRight)
            }
            if (bs) {
              if (bln && this.snapWithAdsorbent) {
                this.top = t
                this.bottom = this.parentHeight - this.top - height
              }
              tem.value.y[0].push(l, r, activeLeft, activeRight)
            }
            if (TS) {
              if (bln && this.snapWithAdsorbent) {
                this.top = b - height
                this.bottom = this.parentHeight - this.top - height
              }
              tem.value.y[1].push(l, r, activeLeft, activeRight)
            }
            if (BS) {
              if (bln && this.snapWithAdsorbent) {
                this.top = b
                this.bottom = this.parentHeight - this.top - height
              }
              tem.value.y[1].push(l, r, activeLeft, activeRight)
            }
            if (ls) {
              if (bln && this.snapWithAdsorbent) {
                this.left = l - width
                this.right = this.parentWidth - this.left - width
              }
              tem.value.x[0].push(t, b, activeTop, activeBottom)
            }
            if (rs) {
              if (bln && this.snapWithAdsorbent) {
                this.left = l
                this.right = this.parentWidth - this.left - width
              }
              tem.value.x[0].push(t, b, activeTop, activeBottom)
            }
            if (LS) {
              if (bln && this.snapWithAdsorbent) {
                this.left = r - width
                this.right = this.parentWidth - this.left - width
              }
              tem.value.x[1].push(t, b, activeTop, activeBottom)
            }
            if (RS) {
              if (bln && this.snapWithAdsorbent) {
                this.left = r
                this.right = this.parentWidth - this.left - width
              }
              tem.value.x[1].push(t, b, activeTop, activeBottom)
            }
            if (hc) {
              if (bln && this.snapWithAdsorbent) {
                this.top = t + h / 2 - height / 2
                this.bottom = this.parentHeight - this.top - height
              }
              tem.value.y[2].push(l, r, activeLeft, activeRight)
            }
            if (vc) {
              if (bln && this.snapWithAdsorbent) {
                this.left = l + w / 2 - width / 2
                this.right = this.parentWidth - this.left - width
              }
              tem.value.x[2].push(t, b, activeTop, activeBottom)
            }
            // 辅助线坐标与是否显示(display)对应的数组,易于循环遍历
            const arrTem = [0, 1, 0, 1, 2, 2, 0, 1, 0, 1, 2, 2]
            for (let i = 0; i <= arrTem.length; i++) {
              // 前6为Y辅助线,后6为X辅助线
              const xory = i < 6 ? "y" : "x"
              const horv = i < 6 ? "hLine" : "vLine"
              if (tem.display[i]) {
                const { origin, length } = this.calcLineValues(tem.value[xory][arrTem[i]])
                refLine[horv][arrTem[i]].display = tem.display[i]
                refLine[horv][arrTem[i]].position = tem.position[i] + "px"
                refLine[horv][arrTem[i]].origin = origin
                refLine[horv][arrTem[i]].lineLength = length
                refLine[horv][arrTem[i]].w = w
                refLine[horv][arrTem[i]].h = h
                refLine[horv][arrTem[i]].cw = this.width
                refLine[horv][arrTem[i]].ch = this.height
              }
            }
          }
        }
        this.$emit("refLineParams", refLine)
      }
    },
    calcLineValues(arr) {
      const length = Math.max(...arr) - Math.min(...arr) + "px"
      const origin = Math.min(...arr) + "px"
      return { length, origin }
    },
    async getActiveAll(nodes) {
      const activeAll = []
      const XArray = []
      const YArray = []
      let groupWidth = 0
      let groupHeight = 0
      let groupLeft = 0
      let groupTop = 0
      for (let item of nodes) {
        if (item.className !== undefined && item.className.includes(this.classNameActive)) {
          activeAll.push(item)
        }
      }
      const AllLength = activeAll.length
      if (AllLength > 1) {
        for (let i of activeAll) {
          const l = i.offsetLeft
          const r = l + i.offsetWidth
          const t = i.offsetTop
          const b = t + i.offsetHeight
          XArray.push(t, b)
          YArray.push(l, r)
        }
        groupWidth = Math.max(...YArray) - Math.min(...YArray)
        groupHeight = Math.max(...XArray) - Math.min(...XArray)
        groupLeft = Math.min(...YArray)
        groupTop = Math.min(...XArray)
      }
      const bln = AllLength === 1
      return { groupWidth, groupHeight, groupLeft, groupTop, bln }
    },
    // 正则获取left与top
    formatPositionVal(el) {
      let [left, top] = el.replace(/[^0-9\-,]/g, "").split(",")
      if (top === undefined) top = 0
      return [+left, +top]
    },
    // 获取当前快照
    getQuickShot() {
      const { width, height, top, left } = this.options
      return [width, height, top, left]
    },
    // 根据组件类型找到列表页中的组件
    isFirstComponent(type, rectId) {
      const firstTypeComponent = this.$store.state[this.request_prefix].page.children[0].children.find(rect => {
        return rect.shape === type
      })
      return firstTypeComponent.rect_id === rectId
    },
    // 是否是列表页的业务组件,业务组件不允许删除
    isListPageBussinessComponent() {
      if (this.isListPageBussinessComponentFlag !== undefined) return this.isListPageBussinessComponentFlag
      let flag = true
      let state = this.$store.state[this.request_prefix]
      const rectAttr = this.getAttrById.call(
        this,
        state,
        this.myId
      )
      if (state.type === "listPage" || state.type === "detailPage") {
        flag = !rectAttr?.preComponent || rectAttr?.shape === "cxBreadCrumbs"
      }
      this.isListPageBussinessComponentFlag = flag
      return this.isListPageBussinessComponentFlag
    },
    // 锚点组件的克隆方法
    clone() {
      const layout = this.$store.state[this.request_prefix].page.pageLayoutList
      // 查找当前通栏的路径
      const path = findCurrentComponentPathInLayoutByRectId(layout, this.myId.rect_id)
      let pageLayout = this.getAttrById.call(
        this,
        this.$store.state[this.request_prefix],
        {
          container_id: this.myId.container_id,
          pageLayoutId: path[0]
        },
        "pageLayout"
      )
      let rectIds = pageLayout?.layout?.rows[0]?.rectIds
      let elementList = []
      let curIndex = 0
      if (rectIds) {
        rectIds.forEach((item, index) => {
          if (item === this.myId.rect_id) {
            curIndex = index
          }
          elementList.push(
            this.$store.state[this.request_prefix].page.children[0].children.find(rect => rect.rect_id === item)
          )
        })
      }
      elementList?.forEach((item, index) => {
        if (index != curIndex) {
          console.log("item :>>", item)

          let content = item.options.content
          let pluginName = item.options.pluginName
          let iconSrc = item.options.iconSrc
          let iconType = item.options.iconType
          item.options = JSON.parse(JSON.stringify(elementList[curIndex].options))
          // 保持不变的元素
          item.options.content = content
          item.options.pluginName = pluginName
          item.options.iconSrc = iconSrc
          item.options.iconType = iconType
          let oldRectId = elementList[curIndex].rect_id
          let newRectId = item.rect_id
          // 同步动画
          copyAnimateRelation(
            this.$store.state[this.request_prefix],
            {
              options: item.options,
              shape: item.options.shape
            },
            oldRectId, //旧的rectId
            newRectId // 新的rectId
          )
        }
      })
    },
    // 打开抽屉、弹出框
    openBox(type) {
      if(type === "drawer") {
        // 广播抽屉状态
        this.$eventBus.$emit("control-drawer", {
          openDrawer: true,
          sourceId: this.options.drawerPath
        })
        this.$changeOptionsEV(true, "openDrawer", false, false, false, true)
      } else if(type === "popover") {
        // 广播弹出框状态
        this.$eventBus.$emit("control-popover", {
          openPopover: true,
          sourceId: this.options.popoverPath
        })
      }
    },
    // 特殊处理，针对handleList中抽屉存在的时候，需要去掉布局这层数据
    removeLayoutHandle() {
      if (this.handleList.find(it => it.name === "抽屉") && this.handleList.find(it => it.name === "布局")) {
        this.handleList = this.handleList.filter(it => it.name !== "布局")
      }
      if (this.isGoTop) {
        this.handleList = this.handleList.filter(it => it.shape !== "cxPageLayoutCell" && it.shape !== "cxPageLayout")
      }
      if(this.handleList.find(it => it.name === "弹出框") && this.handleList.find(it => it.shape === "cxPageLayoutCell")) {
        this.handleList = this.handleList.filter(it => it.shape !== "cxPageLayoutCell")
      }
    }
  },
  computed: {
    isInSubHead() {
      return this?.options?.isInSubHead
    },
    // 工具栏的整体高度
    maxToolHeight() {
      const handleItem  = this.$refs.handleBtns
      this.showMultipleName = handleItem && handleItem.$el.getElementsByClassName("displayBlock").length > 0 ? true : false
      const singleToolHeight = 34
      const singleToolMargin = 2
      const height = this.showMultipleName
        ? singleToolHeight + singleToolMargin * (this.getHandleList.length + 1)
        : singleToolHeight + singleToolMargin * 2
      return height
    },
    scrollLeft(){
      return this.$store.state.states.scrollLeft
    },
    getHandleTopSite(){
      if(isExist(this.myId.swiperContentId) && this.options.top < this.maxToolHeight){
        return {
          top: 0,
          left: `${this.offsetLeft}`
        }
      }
      if(this.offsetType === "top-top") {
        return {
          bottom: "100%",
          left: `${this.offsetLeft}`
        }
      } else if(this.offsetType === "bottom-bottom") {
        return {
          top: "100%",
          left: `${this.offsetLeft}`
        }
      } else {
        return {
          top: `${-this.offsetTop / this.zoom}px`,
          left: `${this.offsetLeft}`
        }
      }
    },
    isLayout() {
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
    disableSetColAndRow() {
      return hasProperty(this.options, "disableSetColAndRow")
    },
    showSetComponentBtn() {
      return hasProperty(this.options, "showSetComponentBtn")
    },
    handleStyle() {
      return stick => {
        if (!this.handleInfo.switch) return { display: this.enabled && !this.dragging ? "block" : "none" }
        if (this.request_prefix === "bigScreen") this.handleInfo.offset = -4
        // 鼠标悬浮时支持修改尺寸
        let vdrHover = false
        if (this.request_prefix !== "bigScreen") {
          vdrHover = $(this.$el).hasClass("vdr_hover")
        }
        const size = this.handleInfo.size
        const offset = this.handleInfo.offset
        const center = (size / 2).toFixed(2)

        const styleMap = {
          tl: {
            top: `${offset}px`,
            left: `${offset}px`
          },
          tm: {
            top: `${offset}px`,
            left: `calc(50% - ${center}px)`
          },
          tr: {
            top: `${offset}px`,
            right: `${offset}px`
          },
          mr: {
            top: `calc(50% - ${center}px)`,
            right: `${offset}px`
          },
          br: {
            bottom: `${offset}px`,
            right: `${offset}px`
          },
          bm: {
            bottom: `${offset}px`,
            right: `calc(50% - ${center}px)`
          },
          bl: {
            bottom: `${offset}px`,
            left: `${offset}px`
          },
          ml: {
            top: `calc(50% - ${center}px)`,
            left: `${offset}px`
          }
        }
        const stickStyle = {
          width: `${size}px`,
          height: `${size}px`,
          top: styleMap[stick].top,
          left: styleMap[stick].left,
          right: styleMap[stick].right,
          bottom: styleMap[stick].bottom
        }
        stickStyle.display = this.enabled && !this.dragging || vdrHover || this.resizing ? "block" : "none"
        // console.log("stickStyle", stickStyle)
        return stickStyle
      }
    },
    borderHandleStyle() {
      console.log("borderHandleStyle", style)
      let style = {}
      style.display = !this.enabled || this.clonePatternStatu ? 'none' : 'block'
      if (this.resizing && this.request_prefix !== "bigScreen") style.display = 'block'
      return style
    },
    getParentOptions() {
      if (this.request_prefix === "bigScreen") return false
      let parentOptions = null
      if (isExist(this.options?.elementInAutoLayoutId)) {
        if (!isExist(this.options?.elementInAutoLayoutId)) return false
        parentOptions = this.getAttrById(this.$store.state[this.request_prefix], this.myId, "autoLayout")
      } else if (isExist(this.options?.elementInLayoutId)) {
        if (!isExist(this.options?.elementInLayoutId)) return false
        let ids1 = {
          container_id: this.myId.container_id,
          rect_id: this.myId.rect_id,
          uid: this.myId.uid
        }
        if(this.request_prefix === "bigScreen"){
          ids1.pageId = this.myId.pageId
        }
        let tempRect = this.getAttrById(this.$store.state[this.request_prefix], ids1)
        if (!tempRect) return false
        const rectOptions = tempRect.options ? tempRect.options : tempRect
        if (rectOptions.innerElement !== "emptyLayoutComponent") return false
        const useActiveIndex = rectOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : rectOptions.activeIndex
        if (!useActiveIndex && useActiveIndex !== 0) return false
        const pOptions = [rectOptions.rows[useActiveIndex]]
        if (!pOptions) return false
        const activeCol = handleFindLayoutComponentOptionsCols(pOptions, this.myId.uid) ||
            handleFindLayoutComponentOptionsCols(pOptions, pOptions[0]?.cols[0]?.uid)
        if (!activeCol || !activeCol?.componentBoxOptions) return false
        return activeCol.componentBoxOptions
      } else if (isExist(this.options?.elementInDataGridId) && isExist(this.myId?.cellId)) {
        let ids1 = {
          container_id: this.myId.container_id,
          rect_id: this.myId.rect_id,
          cellId: this.myId.cellId,
          elementInAutoLayoutId: this.myId.elementInAutoLayoutId,
          path: this.myId.path
        }
        let tempRect = this.getAttrById(this.$store.state[this.request_prefix], ids1)
        if (!tempRect) return false
        const cellOptions = tempRect.options ? tempRect.options : tempRect
        if (!cellOptions) return false
        return cellOptions
      } else if (Object.keys(this.myId).length === 2) {
        if (this.pageLayoutParentOptions) return this.pageLayoutParentOptions
        if (this.myId.hasOwnProperty("container_id") && this.myId.hasOwnProperty("rect_id")) {
          let pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList || []
          const path = findCurrentComponentPathInLayoutByRectId(pageLayoutList, this.myId.rect_id).join("_")
          let parentRectId, pageLayoutId
          // if (!path) {
            if (isExist(this.myId.rect_id) && !isExist(this.myId.pageLayoutId)) {
              ;[ parentRectId, pageLayoutId ] = findPathInComponentLayoutByRectId(this.myId)
            }
          //   if (!parentRectId) return false
          // }
          if (parentRectId) {
            parentOptions = this.getAttrById(this.$store.state[this.request_prefix], {
              container_id: this.myId.container_id,
              rect_id: Number(parentRectId),
              pageLayoutId: pageLayoutId
            })?.options
          } else {
            parentOptions = this.getAttrById.call(
              this,
              this.$store.state[this.request_prefix],
              {
                container_id: this.myId.container_id,
                pageLayoutId: path
              },
              "pageLayout"
            )?.options
          }
          this.pageLayoutParentOptions = parentOptions
          return this.pageLayoutParentOptions
        }
      }
      return parentOptions
    },
    style() {
      let widthUnit = "px"
      let heightUnit = "px"
      let showRowColLayout = this.getParentOptions?.showRowColLayout
      if (this.options) {
        let width = this.computedWidth,
          height = this.computedHeight
        // 位置设置百分比
        let marginLeft,
          marginTop,
          transformLeft = `${this.left}px`,
          transformTop = `${this.top}px`
        if (this.options.leftType === "%" && !showRowColLayout) {
          let offsetLeft = this.options.offset ? this.options.offset[1] - this.options.offset[3] : 0
          marginLeft = `calc(${this.options.left}% - ${offsetLeft}px)`
          transformLeft = this.options.margin ? this.options.margin[3] : "0px"
        }
        if (this.options.topType === "%" && !showRowColLayout) {
          let offsetTop = this.options.offset ? this.options.offset[2] - this.options.offset[0] : 0
          marginTop = `calc(${this.options.top}% - ${offsetTop}px)`
          transformTop = this.options.margin ? this.options.margin[0] : "0px"
        }
        let transform = `translate(${transformLeft}, ${transformTop})`

        //列表页的分页的旧数据存在尺寸过大的问题。需要添加判断来修改为自适应尺寸
        let state = this.$store.state[this.request_prefix]
        if(state.type === "listPage" && this.options.innerElement === "cxPagination" && isExist(this.myId.elementInLayoutId)){
          this.options.widthType = "自动"
          this.options.heightType = "自动"
        }
        if (this.options.isNoConflictCheck) {
          widthUnit = this.options.widthType === "自动" ? "" : "px"
          heightUnit = this.options.heightType === "自动" ? "" : "px"
          width =
            this.options.widthType === "%" ? parseInt((this.computedWidth * this.parentW) / 100) : this.computedWidth
          height =
            this.options.heightType === "%" ? parseInt((this.computedHeight * this.parentH) / 100) : this.computedHeight
        } else {
          switch (this.options.widthType) {
            case "自动":
              width = "auto"
              widthUnit = ""
              break
            case "%":
              widthUnit = "%"
              break
            default:
          }
          switch (this.options.heightType) {
            case "自动":
              height = "auto"
              heightUnit = ""
              break
            case "%":
              heightUnit = "%"
              break
            default:
          }
        }
        let maxWidth, minWidth, maxHeight, minHeight
        let customShapes = ["cxText", "cxNavMenuVertical", "cxLogicText", "cxNavMenu", "cxWeather", "cxDate", "cxMultiFilter", "cxButton", "cxIcon", "imageComponent", "cxVideo", "cxAudio", "cxTabs", "cxLabel", "cxHomeLine", "cxVerticalLine", "cxIframe", "cxTable", "cxBar", "cxLine", "cxPie", "cxRadar", "cxCloud", "emptyLayoutComponent", "cxEditor", "cxBreadCrumbs", "cxNoteEditor", "cxCalendar", "cxSelect", "cxIframe", "swiperComponent", "cxInput", "cxAnchorComponent", "cxPagination", "cxDigitRoll", "cxSort", "cxShare",
        "cxCountdown"] //可以在自动布局下切换尺寸设置的组件
        if (this.options.showRowColLayout || customShapes.includes(this.options.innerElement)) {
          /* 自动布局 */
          let options = this.options
          maxWidth = options.showMaxWidth ? options.maxWidth + "px" : ""
          minWidth = options.showMinWidth ? options.minWidth + "px" : ""
          maxHeight = options.showMaxHeight ? options.maxHeight + "px" : ""
          minHeight = options.showMinHeight ? options.minHeight + "px" : ""
        }
        // 如果当前元素宽度自适应，内部元素为空，设置默认宽度避免宽度为0选不中布局
        if (showRowColLayout && this.options.widthType === "自动") {
          let elementOptions = this.options?.elementOptions
          if (customShapes.includes(this.options.innerElement)) {// 当前元素为可自定义宽高元素
            if (!isExist(fixOptName([this.options.innerElement]))) width = "100px"
          } else if (!elementOptions || elementOptions?.length === 0) {
            width = 400 + "px"
          } else {
            // 当前布局下的所有元素都是宽度充满，且没有填充子元素
            let noWidth = elementOptions.every(item => {
              let noElement = !item.elementOptions || item.elementOptions.length === 0
              return this.options.widthType === "%" && noElement
            })
            if (noWidth) width = 400 + "px"
          }
        }
        // 如果当前元素设置高度自适应，内部元素为空，设置默认高度避免高度为0选不中布局 预览页不需要
        if (showRowColLayout && this.options.heightType === "自动") {
          let elementOptions = this.options?.elementOptions
          if (this.options.innerElement === "cxDataGrid") {
            elementOptions = this.options.cells
          }
          if (customShapes.includes(this.options.innerElement)) {// 当前元素为可自定义宽高元素
            if (!isExist(fixOptName([this.options.innerElement]))) height = "34px"
          } else if (!elementOptions || elementOptions?.length === 0) {
            height = 200 + "px"
            this.$changeOptionsEV(200, "height", false, null, this.myId, true)
            this.$changeOptionsEV("px", "heightType", false, null, this.myId, true)
          } else {
            // 当前布局下的所有元素都是高度充满，且没有填充子元素
            let noHeight = elementOptions.every(item => {
              let noElement = !item.elementOptions || item.elementOptions.length === 0
              return this.options.heightType === "%" && noElement
            })
            if (noHeight) {
              height = 200 + "px"
              this.$changeOptionsEV(200, "height", false, null, this.myId, true)
              this.$changeOptionsEV("px", "heightType", false, null, this.myId, true)
            }
          }
        }
        let flex
        if (showRowColLayout) {// 所在布局为自动布局
          // 兼容单元格下的组件开启自动布局的尺寸
          if (this.options.widthType === "%" && !(isExist(this.options.elementInLayoutId) && this.options.width !== 100)) {// 宽度充满
            width = 100
            // 父级水平对齐并且当前元素设置宽度充满，需要平分剩余宽度
            if (this.getParentOptions.rowColDirection === "horizon") {
              flex = 1
              // 最小值预览页不需要
              minWidth = minWidth ? minWidth : "20px"
            }
          }
          // 兼容单元格下的组件开启自动布局的尺寸
          if (this.options.heightType === "%" && !(isExist(this.options.elementInLayoutId) && this.options.height !== 100)) {// 高度充满
            height = 100
            // 父级垂直对齐并且当前元素设置高度充满，需要平分剩余高度
            if (this.getParentOptions.rowColDirection !== "horizon") {
              flex = 1
              // 最小值预览页不需要
              minHeight = minHeight ? minHeight : "20px"
            }
          }
          /* 产品要求编辑页不允许自动布局不允许变成一条线 预览页不需要*/
          if (this.options.widthType === "自动") {
            minWidth = minWidth ? minWidth : "20px"
          }
          if (this.options.heightType === "自动") {
            minHeight = minHeight ? minHeight : "20px"
          }
          width = width < 20 ? 20 : width
          height = height < 20 ? 20 : height
        }
        let zIndex = this.options?.zIndex ? this.options.zIndex : 0
        let nowrap = width === 'auto' && this.options.isQuickSite  && !maxWidth? 'nowrap':''
        // 返回顶部按钮始终充满所在通栏
        if(this.isGoTop) {
          marginLeft = 0
          marginTop = 0
          transform = null
          width = 100
          widthUnit = "%"
          height = 100
          heightUnit = "%"
        }
        const cacheStyle =  {
          marginLeft: marginLeft,
          top: marginTop,
          transform: transform,
          width: width + widthUnit,
          height: height + heightUnit,
          whiteSpace:nowrap,
          maxWidth: maxWidth,
          minWidth: minWidth,
          maxHeight: maxHeight,
          minHeight: minHeight,
          zIndex: zIndex,
          flex: flex,
          ...this.publicStyle,
          ...(this.dragging && this.disableUserSelect ? userSelectNone : userSelectAuto)
        }
        return cacheStyle
      }
    },
    publicStyle() {
      let style = {}
      const { showBackgroundFilter, backgroundFilter } = this.options
      if (showBackgroundFilter) {
        style['--BackdropFilter'] = `blur(${backgroundFilter}px)`
      }
      return style
    },
    // 每次动画时候再调用
    // animateStyle() {
    //   return this.getAnimateVariableStyle(this.options, this.myId)
    // },
    // 控制柄显示与否
    actualHandles() {
      if (this.options?.innerElement === "cxShare") return [] // 不能拖拽尺寸的组件
      if (this.options?.innerElement === "cxCountdown" &&
        this.options?.widthType === "自动" &&
        this.options?.heightType === "自动"
      ) return []
      if (!this.resizable) return []
      return this.handles
    },
    borderHandles() {
      if (!this.enabled && !this.request_prefix === "bigScreen") return []
      return this.borderList
    },
    computedWidth() {
      if (this.w === "auto") {
        if (!this.widthTouched) {
          return "auto"
        }
      }
      return this.width || this.w
    },
    computedHeight() {
      if (this.h === "auto") {
        if (!this.heightTouched) {
          return "auto"
        }
      }
      return this.height || this.h
    },
    resizingOnX() {
      return Boolean(this.handle) && (this.handle.includes("l") || this.handle.includes("r"))
    },
    resizingOnY() {
      return Boolean(this.handle) && (this.handle.includes("t") || this.handle.includes("b"))
    },
    isCornerHandle() {
      return Boolean(this.handle) && ["tl", "tr", "br", "bl"].includes(this.handle)
    },
    rect() {
      return {
        left: Math.round(this.left),
        top: Math.round(this.top),
        right: Math.round(this.right),
        bottom: Math.round(this.bottom),
        width: Math.round(this.width),
        height: Math.round(this.height),
        isQuickSite:this.options.isQuickSite
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    activeSingle() {
      if (localStorage.getItem("multipleComponent")) {
        return this.active
      } else {
        // console.log("this.myId :>>", this.myId, this.ids, isEqual(this.myId, this.ids))
        return isEqual(this.myId, this.ids)
      }
    },
    isDraggable() {
      // 每个元素都允许拖动
      return this.draggable
    },
    isPageLayoutTabs() {
      return this.options?.hasOwnProperty("isPageLayoutTabs") ? this.options?.isPageLayoutTabs : false
    },
    // 用于需要控制组件显示隐藏 但是不需要删除组件时
    isElementShow() {
      if (this.options && this.options.isShow !== null && typeof this.options.isShow !== "undefined") {
        return this.options.isShow
      }
      return true
    },
    isCanDel() {
      // 登录框的标签组件
      if (this.options && (this.options.innerElement === "cxTabs" || (this.options.innerElement === 'cxSelect' && this.options.quoteTo === "cxTabs"))) {
        const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.myId, "rect")
        if(rectAttr && rectAttr.options && isExist(rectAttr.options.parentRectId)){
          // 栅格下标签布局下的tab
          return false
        }
        if (
          rectAttr &&
          rectAttr.options &&
          rectAttr.options.pluginName &&
          rectAttr.options.pluginName.includes("loginEngineComponentPlugin")
        ) {
          return false
        }
      }
      // 搜索内部指定组件 不允许删除 loginType：登录框内部组件
      if (this.options && this.options.searchType) return false
      if (this.options && this.options.loginType) return false
      // 用户须知内部组件，不允许删除
      if (this.options && this.options.noticeInnerComp) return false
      // 返回顶部按钮，不允许删除
      if (this.isGoTop) return false
      // 弹出框关闭按钮，不允许删除
      if (this.options?.pluginName?.includes("controlPopoverPlugin")) return false
      return true
    },
    // 自由布局克隆或者排序
    clonePatternStatu() {
      return this.$store.state.states.isClonePattern || this.$store.state.states.isOrderPattern
    },
    handleListGetter() {
      let handleList = findParentIds(
        this.myId,
        this.$store.state[this.request_prefix].page.pageLayoutType,
        this.$store.state[this.request_prefix]
      ) || []
      this.handleBtnStr.ids = this.myId
      this.handleBtnStr.shape = this.options.innerElement
      handleList.push(this.handleBtnStr)
      //  栅格模式下的布局需要更名为 内容区
      let isWaterFall = this.$store.state[this.request_prefix].page.isWaterFall  === 'waterFall' ? true : false
      isWaterFall && handleList.forEach(item=>{
        if(item.name?.trim() === '布局' &&  !isExist(item.ids.rect_id)){
          item.name = '内容区'
        }
      })
      return handleList
    },
    getHandleList() {
      if(this.offsetType === "top-top" || this.offsetType === "bottom-top") {
        return this.handleList
      } else {
        return simpleDeepClone(this.handleList).reverse()
      }
    },
    isGoTop() {
      return this.options?.pluginName?.includes("goTopPlugin")
    }
  },
  watch: {
    draggingOrResizing() {
      this.$emit("dragStatuChange", this.draggingOrResizing)
    },
    parentW() {
      this.checkParentSize()
    },
    parentH() {
      this.checkParentSize()
      this.bounds = this.calcDragLimits()
    },
    active: {
      handler: function (val, oldVal) {
        this.enabled = val
        if (val) {
          this.handleList = this.handleListGetter
          this.changeBoundSize("all")
          addEvent(document.documentElement, "wheel", this.changeBtnPosition, false)
        } else {
          if (!this.$store.state.states.alignHelperStatus) {
            removeEvent(document.documentElement, "wheel", this.changeBtnPosition, false)
          }
        }
      },
      immediate: true,
      deep: false
    },
    scrollLeft(){
      if(!this.active){
        return
      }
      let zoom = this.zoom || 1
      let element =  this.$el.getBoundingClientRect()
      if(!element){
        return
      }
      let leftmenuWidth = document.getElementsByClassName("left-menu-wrap")[0]?.getBoundingClientRect()?.width || 0
      if(element.left <  leftmenuWidth && element.left + element.width > leftmenuWidth){
        this.offsetLeft = (leftmenuWidth - element.left)/zoom
      }else{
        this.offsetLeft = 0
      }
    },
    "options.rowColDirection"(newVal, oldVal) {
      console.log('newVal :>>',newVal,oldVal);
      if (newVal !== oldVal) {
        if (newVal === "horizon") {
          this.handleBtnStr.name = "列布局"
          this.handleBtnStr.iconClass = "icon-portal-icon_column"
        } else {
          this.handleBtnStr.name = "行布局"
          this.handleBtnStr.iconClass = "icon-portal-icon_row"
        }
        this.$changeOptionsEV(this.handleBtnStr.name, "name", false, null, this.myId, true)
        this.$changeOptionsEV(this.handleBtnStr.name, "menuName", false, null, this.myId, true)
        this.$changeOptionsEV(this.handleBtnStr.iconClass, "menuIconClass", false, null, this.myId, true)
      }
    },
    z(val) {
      if (val >= 0 || val === "auto") {
        this.zIndex = val
      }
    },
    x(val) {
      if (this.resizing || this.dragging) {
        return
      }

      if (this.parent) {
        this.bounds = this.calcDragLimits()
      }

      this.moveHorizontally(val)
    },
    y(val) {
      if (this.resizing || this.dragging) {
        return
      }

      if (this.parent) {
        this.bounds = this.calcDragLimits()
      }

      this.moveVertically(val)
    },
    lockAspectRatio(val) {
      if (val) {
        this.aspectFactor = this.width / this.height
      } else {
        this.aspectFactor = undefined
      }
    },
    minWidth(val) {
      if (val > 0 && val <= this.width) {
        this.minW = val
      }
    },
    minHeight(val) {
      if (val > 0 && val <= this.height) {
        this.minH = val
      }
    },
    maxWidth(val) {
      this.maxW = val
    },
    maxHeight(val) {
      this.maxH = val
    },
    w(val) {
      this.changeBoundSize("width")
      if (this.resizing || this.dragging) {
        return
      }

      if (this.parent) {
        this.bounds = this.calcResizeLimits()
      }

      this.changeWidth(val)
    },
    h(val) {
      this.changeBoundSize("height")
      if (this.resizing || this.dragging) {
        return
      }

      if (this.parent) {
        this.bounds = this.calcResizeLimits()
      }

      this.changeHeight(val)
    }
  }
}
</script>
